/**
 * Auto-generated Locale Data File for hi-IN.
 * This is generated in the @box/cldr-data project.
 * @IMPORTANT: DO NOT MODIFY THIS FILE DIRECTLY
 */

import type { NumberFormat, NumbersData, NameItem, LanguagesData, LocaleData, TimeZone, TimeZoneList, WeekData, WeekDayNameData, NameSet, WeekDayNames } from '../types';

const languages: LanguagesData = {
    id: 71,
    bcp47Tag: 'hi-IN',
    name: 'Hindi',
    localizedName: 'हिन्दी',
    localizedNameList: [
        {
            id: 4,
            name: 'अंग्रेज़ी',
        },
        {
            id: 16,
            name: 'इतालवी',
        },
        {
            id: 67,
            name: 'ऑस्ट्रेलियाई अंग्रेज़ी',
        },
        {
            id: 66,
            name: 'कनाडाई अंग्रेज़ी',
        },
        {
            id: 65,
            name: 'कनाडाई फ़्रेंच',
        },
        {
            id: 55,
            name: 'कोरियाई',
        },
        {
            id: 18,
            name: 'जर्मन',
        },
        {
            id: 19,
            name: 'जापानी',
        },
        {
            id: 24,
            name: 'डच',
        },
        {
            id: 68,
            name: 'डेनिश',
        },
        {
            id: 49,
            name: 'तुर्की',
        },
        {
            id: 69,
            name: 'नॉर्वेजियाई बोकमाल',
        },
        {
            id: 63,
            name: 'पारंपरिक चीनी',
        },
        {
            id: 14,
            name: 'पुर्तगाली',
        },
        {
            id: 30,
            name: 'पोलिश',
        },
        {
            id: 61,
            name: 'फ़िनिश',
        },
        {
            id: 21,
            name: 'फ़्रेंच',
        },
        {
            id: 70,
            name: 'बंगाली',
        },
        {
            id: 59,
            name: 'ब्रिटिश अंग्रेज़ी',
        },
        {
            id: 8,
            name: 'रूसी',
        },
        {
            id: 72,
            name: 'लैटिन अमेरिकी स्पेनिश',
        },
        {
            id: 6,
            name: 'सरलीकृत चीनी',
        },
        {
            id: 10,
            name: 'स्पेनिश',
        },
        {
            id: 57,
            name: 'स्वीडिश',
        },
        {
            id: 71,
            name: 'हिन्दी',
        },
    ],
};

const numbers: NumbersData = {
    long: [
        {
            digits: 1,
            msg: '{count, number}',
        },
        {
            digits: 2,
            msg: '{count, number}',
        },
        {
            digits: 3,
            msg: '{count, number}',
        },
        {
            digits: 1,
            msg: '{count, number} हज़ार',
        },
        {
            digits: 2,
            msg: '{count, number} हज़ार',
        },
        {
            digits: 1,
            msg: '{count, number} लाख',
        },
        {
            digits: 2,
            msg: '{count, number} लाख',
        },
        {
            digits: 1,
            msg: '{count, number} करोड़',
        },
        {
            digits: 2,
            msg: '{count, number} करोड़',
        },
        {
            digits: 1,
            msg: '{count, number} अरब',
        },
        {
            digits: 2,
            msg: '{count, number} अरब',
        },
        {
            digits: 1,
            msg: '{count, number} खरब',
        },
        {
            digits: 2,
            msg: '{count, number} खरब',
        },
        {
            digits: 3,
            msg: '{count, number} खरब',
        },
    ],
    short: [
        {
            digits: 1,
            msg: '{count, number}',
        },
        {
            digits: 2,
            msg: '{count, number}',
        },
        {
            digits: 3,
            msg: '{count, number}',
        },
        {
            digits: 1,
            msg: '{count, number} हज़ार',
        },
        {
            digits: 2,
            msg: '{count, number} हज़ार',
        },
        {
            digits: 1,
            msg: '{count, number} लाख',
        },
        {
            digits: 2,
            msg: '{count, number} लाख',
        },
        {
            digits: 1,
            msg: '{count, number} क॰',
        },
        {
            digits: 2,
            msg: '{count, number} क॰',
        },
        {
            digits: 1,
            msg: '{count, number} अ॰',
        },
        {
            digits: 2,
            msg: '{count, number} अ॰',
        },
        {
            digits: 1,
            msg: '{count, number} ख॰',
        },
        {
            digits: 2,
            msg: '{count, number} ख॰',
        },
        {
            digits: 1,
            msg: '{count, number} नील',
        },
    ],
};

const timezones: Array<TimeZone> = [
    {
        name: 'Pacific/Kiritimati',
        displayName: 'GMT+14:00 किरीतिमाति +14',
        nameLocalized: 'किरीतिमाति',
        abbreviationStandard: '+14',
        id: 500,
        enabled: true
    },
    {
        name: 'Etc/GMT-14',
        displayName: 'GMT+14:00 GMT-14 +14',
        nameLocalized: 'GMT-14',
        abbreviationStandard: '+14',
        id: 375
    },
    {
        name: 'Pacific/Apia',
        displayName: 'GMT+13:00 एपिया +13/+14',
        nameLocalized: 'एपिया',
        abbreviationStandard: '+13/+14',
        id: 485
    },
    {
        name: 'Pacific/Tongatapu',
        displayName: 'GMT+13:00 टोंगाटापू +13/+14',
        nameLocalized: 'टोंगाटापू',
        abbreviationStandard: '+13/+14',
        id: 520,
        enabled: true
    },
    {
        name: 'Pacific/Fakaofo',
        displayName: 'GMT+13:00 फ़ाकाओफ़ो +13',
        nameLocalized: 'फ़ाकाओफ़ो',
        abbreviationStandard: '+13',
        id: 491
    },
    {
        name: 'Etc/GMT-13',
        displayName: 'GMT+13:00 GMT-13 +13',
        nameLocalized: 'GMT-13',
        abbreviationStandard: '+13',
        id: 374
    },
    {
        name: 'Pacific/Chatham',
        displayName: 'GMT+12:45 चैथम +1245/+1345',
        nameLocalized: 'चैथम',
        abbreviationStandard: '+1245/+1345',
        abbreviationDaylight: '+1245/+1345',
        id: 487
    },
    {
        name: 'Asia/Anadyr',
        displayName: 'GMT+12:00 अनाडिर +12',
        nameLocalized: 'अनाडिर',
        abbreviationStandard: '+12',
        id: 216
    },
    {
        name: 'Pacific/Auckland',
        displayName: 'GMT+12:00 ऑकलैंड NZST',
        nameLocalized: 'ऑकलैंड',
        abbreviationStandard: 'NZST',
        abbreviationDaylight: 'NZDT',
        id: 486,
        enabled: true
    },
    {
        name: 'Asia/Kamchatka',
        displayName: 'GMT+12:00 कमचत्का +12',
        nameLocalized: 'कमचत्का',
        abbreviationStandard: '+12',
        id: 249
    },
    {
        name: 'Pacific/Kwajalein',
        displayName: 'GMT+12:00 क्वाज़ालीन +12',
        nameLocalized: 'क्वाज़ालीन',
        abbreviationStandard: '+12',
        id: 502
    },
    {
        name: 'Pacific/Tarawa',
        displayName: 'GMT+12:00 टारावा +12',
        nameLocalized: 'टारावा',
        abbreviationStandard: '+12',
        id: 519
    },
    {
        name: 'Pacific/Nauru',
        displayName: 'GMT+12:00 नौरु +12',
        nameLocalized: 'नौरु',
        abbreviationStandard: '+12',
        id: 506
    },
    {
        name: 'Pacific/Fiji',
        displayName: 'GMT+12:00 फ़िजी +12/+13',
        nameLocalized: 'फ़िजी',
        abbreviationStandard: '+12/+13',
        id: 492,
        enabled: true
    },
    {
        name: 'Pacific/Funafuti',
        displayName: 'GMT+12:00 फ़्यूनाफ़ुटी +12',
        nameLocalized: 'फ़्यूनाफ़ुटी',
        abbreviationStandard: '+12',
        id: 493
    },
    {
        name: 'Pacific/Majuro',
        displayName: 'GMT+12:00 माजुरो +12',
        nameLocalized: 'माजुरो',
        abbreviationStandard: '+12',
        id: 503
    },
    {
        name: 'Antarctica/McMurdo',
        displayName: 'GMT+12:00 मैकमुर्डो NZST',
        nameLocalized: 'मैकमुर्डो',
        abbreviationStandard: 'NZST',
        abbreviationDaylight: 'NZDT',
        id: 206
    },
    {
        name: 'Pacific/Wallis',
        displayName: 'GMT+12:00 वालिस +12',
        nameLocalized: 'वालिस',
        abbreviationStandard: '+12',
        id: 523
    },
    {
        name: 'Pacific/Wake',
        displayName: 'GMT+12:00 वेक +12',
        nameLocalized: 'वेक',
        abbreviationStandard: '+12',
        id: 522
    },
    {
        name: 'Kwajalein',
        displayName: 'GMT+12:00 Kwajalein +12',
        nameLocalized: 'Kwajalein',
        abbreviationStandard: '+12',
        id: 474
    },
    {
        name: 'NZ',
        displayName: 'GMT+12:00 NZ NZST',
        nameLocalized: 'NZ',
        abbreviationStandard: 'NZST',
        abbreviationDaylight: 'NZDT',
        id: 483
    },
    {
        name: 'Antarctica/South_Pole',
        displayName: 'GMT+12:00 South Pole NZST',
        nameLocalized: 'South Pole',
        abbreviationStandard: 'NZST',
        abbreviationDaylight: 'NZDT',
        id: 209
    },
    {
        name: 'Pacific/Efate',
        displayName: 'GMT+11:00 एफ़ेट +11/+12',
        nameLocalized: 'एफ़ेट',
        abbreviationStandard: '+11/+12',
        id: 489
    },
    {
        name: 'Pacific/Kosrae',
        displayName: 'GMT+11:00 कोसराए +11',
        nameLocalized: 'कोसराए',
        abbreviationStandard: '+11',
        id: 501
    },
    {
        name: 'Pacific/Guadalcanal',
        displayName: 'GMT+11:00 ग्वाडलकनाल +11',
        nameLocalized: 'ग्वाडलकनाल',
        abbreviationStandard: '+11',
        id: 496
    },
    {
        name: 'Pacific/Norfolk',
        displayName: 'GMT+11:00 नॉरफ़ॉक +11/+12',
        nameLocalized: 'नॉरफ़ॉक',
        abbreviationStandard: '+11/+12',
        abbreviationDaylight: '+11/+12',
        id: 508
    },
    {
        name: 'Pacific/Noumea',
        displayName: 'GMT+11:00 नौमिया +11/+12',
        nameLocalized: 'नौमिया',
        abbreviationStandard: '+11/+12',
        id: 509
    },
    {
        name: 'Pacific/Ponape',
        displayName: 'GMT+11:00 पोनपेई +11',
        nameLocalized: 'पोनपेई',
        abbreviationStandard: '+11',
        id: 513
    },
    {
        name: 'Asia/Magadan',
        displayName: 'GMT+11:00 मागादान +11',
        nameLocalized: 'मागादान',
        abbreviationStandard: '+11',
        id: 259,
        enabled: true
    },
    {
        name: 'Asia/Sakhalin',
        displayName: 'GMT+11:00 सखालिन +11',
        nameLocalized: 'सखालिन',
        abbreviationStandard: '+11',
        id: 275
    },
    {
        name: 'Australia/Lord_Howe',
        displayName: 'GMT+10:30 लॉर्ड होवे +1030/+11',
        nameLocalized: 'लॉर्ड होवे',
        abbreviationStandard: '+1030/+11',
        abbreviationDaylight: '+1030/+11',
        id: 320
    },
    {
        name: 'Australia/LHI',
        displayName: 'GMT+10:30 LHI +1030/+11',
        nameLocalized: 'LHI',
        abbreviationStandard: '+1030/+11',
        abbreviationDaylight: '+1030/+11',
        id: 318
    },
    {
        name: 'Pacific/Guam',
        displayName: 'GMT+10:00 गुआम ChST',
        nameLocalized: 'गुआम',
        abbreviationStandard: 'ChST',
        id: 497,
        enabled: true
    },
    {
        name: 'Pacific/Truk',
        displayName: 'GMT+10:00 चक +10',
        nameLocalized: 'चक',
        abbreviationStandard: '+10',
        id: 521
    },
    {
        name: 'Antarctica/DumontDUrville',
        displayName: 'GMT+10:00 ड्यूमोंट डी अर्विले +10',
        nameLocalized: 'ड्यूमोंट डी अर्विले',
        abbreviationStandard: '+10',
        id: 204
    },
    {
        name: 'Pacific/Port_Moresby',
        displayName: 'GMT+10:00 पोर्ट मोरेस्बी +10',
        nameLocalized: 'पोर्ट मोरेस्बी',
        abbreviationStandard: '+10',
        id: 514
    },
    {
        name: 'Australia/Brisbane',
        displayName: 'GMT+10:00 ब्रिस्बन AEST',
        nameLocalized: 'ब्रिस्बन',
        abbreviationStandard: 'AEST',
        id: 311,
        enabled: true
    },
    {
        name: 'Australia/Melbourne',
        displayName: 'GMT+10:00 मेलबोर्न AEST',
        nameLocalized: 'मेलबोर्न',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 321
    },
    {
        name: 'Australia/Lindeman',
        displayName: 'GMT+10:00 लिंडेमान AEST',
        nameLocalized: 'लिंडेमान',
        abbreviationStandard: 'AEST',
        id: 319
    },
    {
        name: 'Asia/Vladivostok',
        displayName: 'GMT+10:00 व्लादिवोस्तोक +10',
        nameLocalized: 'व्लादिवोस्तोक',
        abbreviationStandard: '+10',
        id: 293,
        enabled: true
    },
    {
        name: 'Pacific/Saipan',
        displayName: 'GMT+10:00 सायपान ChST',
        nameLocalized: 'सायपान',
        abbreviationStandard: 'ChST',
        id: 516
    },
    {
        name: 'Australia/Sydney',
        displayName: 'GMT+10:00 सिडनी AEST',
        nameLocalized: 'सिडनी',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 327,
        enabled: true
    },
    {
        name: 'Australia/Hobart',
        displayName: 'GMT+10:00 होबार्ट AEST',
        nameLocalized: 'होबार्ट',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 317,
        enabled: true
    },
    {
        name: 'Australia/ACT',
        displayName: 'GMT+10:00 ACT AEST',
        nameLocalized: 'ACT',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 309
    },
    {
        name: 'Australia/Canberra',
        displayName: 'GMT+10:00 Canberra AEST',
        nameLocalized: 'Canberra',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 313
    },
    {
        name: 'Australia/Currie',
        displayName: 'GMT+10:00 Currie AEST',
        nameLocalized: 'Currie',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 314
    },
    {
        name: 'Australia/NSW',
        displayName: 'GMT+10:00 NSW AEST',
        nameLocalized: 'NSW',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 323
    },
    {
        name: 'Australia/Queensland',
        displayName: 'GMT+10:00 Queensland AEST',
        nameLocalized: 'Queensland',
        abbreviationStandard: 'AEST',
        id: 325
    },
    {
        name: 'Australia/Tasmania',
        displayName: 'GMT+10:00 Tasmania AEST',
        nameLocalized: 'Tasmania',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 328
    },
    {
        name: 'Australia/Victoria',
        displayName: 'GMT+10:00 Victoria AEST',
        nameLocalized: 'Victoria',
        abbreviationStandard: 'AEST',
        abbreviationDaylight: 'AEDT',
        id: 329
    },
    {
        name: 'Pacific/Yap',
        displayName: 'GMT+10:00 Yap +10',
        nameLocalized: 'Yap',
        abbreviationStandard: '+10',
        id: 524
    },
    {
        name: 'Australia/Adelaide',
        displayName: 'GMT+09:30 एडिलेड ACST',
        nameLocalized: 'एडिलेड',
        abbreviationStandard: 'ACST',
        abbreviationDaylight: 'ACDT',
        id: 310,
        enabled: true
    },
    {
        name: 'Australia/Darwin',
        displayName: 'GMT+09:30 डार्विन ACST',
        nameLocalized: 'डार्विन',
        abbreviationStandard: 'ACST',
        id: 315,
        enabled: true
    },
    {
        name: 'Australia/Broken_Hill',
        displayName: 'GMT+09:30 ब्रोकन हिल ACST',
        nameLocalized: 'ब्रोकन हिल',
        abbreviationStandard: 'ACST',
        abbreviationDaylight: 'ACDT',
        id: 312
    },
    {
        name: 'Australia/North',
        displayName: 'GMT+09:30 North ACST',
        nameLocalized: 'North',
        abbreviationStandard: 'ACST',
        id: 322
    },
    {
        name: 'Australia/South',
        displayName: 'GMT+09:30 South ACST',
        nameLocalized: 'South',
        abbreviationStandard: 'ACST',
        abbreviationDaylight: 'ACDT',
        id: 326
    },
    {
        name: 'Australia/Yancowinna',
        displayName: 'GMT+09:30 Yancowinna ACST',
        nameLocalized: 'Yancowinna',
        abbreviationStandard: 'ACST',
        abbreviationDaylight: 'ACDT',
        id: 331
    },
    {
        name: 'Asia/Jayapura',
        displayName: 'GMT+09:00 जयापुरा WIT',
        nameLocalized: 'जयापुरा',
        abbreviationStandard: 'WIT',
        id: 246
    },
    {
        name: 'Asia/Tokyo',
        displayName: 'GMT+09:00 टोक्यो JST',
        nameLocalized: 'टोक्यो',
        abbreviationStandard: 'JST',
        id: 287,
        enabled: true
    },
    {
        name: 'Asia/Dili',
        displayName: 'GMT+09:00 डिलि +09',
        nameLocalized: 'डिलि',
        abbreviationStandard: '+09',
        id: 236
    },
    {
        name: 'Pacific/Palau',
        displayName: 'GMT+09:00 पलाऊ +09',
        nameLocalized: 'पलाऊ',
        abbreviationStandard: '+09',
        id: 511
    },
    {
        name: 'Asia/Pyongyang',
        displayName: 'GMT+09:00 प्योंगयांग KST',
        nameLocalized: 'प्योंगयांग',
        abbreviationStandard: 'KST',
        id: 269
    },
    {
        name: 'Asia/Yakutsk',
        displayName: 'GMT+09:00 याकूत्स्क +09',
        nameLocalized: 'याकूत्स्क',
        abbreviationStandard: '+09',
        id: 294,
        enabled: true
    },
    {
        name: 'Asia/Seoul',
        displayName: 'GMT+09:00 सिओल KST',
        nameLocalized: 'सिओल',
        abbreviationStandard: 'KST',
        id: 277,
        enabled: true
    },
    {
        name: 'Australia/Eucla',
        displayName: 'GMT+08:45 यूक्ला +0845/+0945',
        nameLocalized: 'यूक्ला',
        abbreviationStandard: '+0845/+0945',
        id: 316
    },
    {
        name: 'Asia/Irkutsk',
        displayName: 'GMT+08:00 इर्कुत्स्क +08',
        nameLocalized: 'इर्कुत्स्क',
        abbreviationStandard: '+08',
        id: 243
    },
    {
        name: 'Asia/Ulaanbaatar',
        displayName: 'GMT+08:00 उलानबातर +08/+09',
        nameLocalized: 'उलानबातर',
        abbreviationStandard: '+08/+09',
        id: 289,
        enabled: true
    },
    {
        name: 'Asia/Kuala_Lumpur',
        displayName: 'GMT+08:00 कुआलालंपुर +08',
        nameLocalized: 'कुआलालंपुर',
        abbreviationStandard: '+08',
        id: 254,
        enabled: true
    },
    {
        name: 'Asia/Kuching',
        displayName: 'GMT+08:00 कूचिंग +08',
        nameLocalized: 'कूचिंग',
        abbreviationStandard: '+08',
        id: 255
    },
    {
        name: 'Antarctica/Casey',
        displayName: 'GMT+08:00 केसी +08',
        nameLocalized: 'केसी',
        abbreviationStandard: '+08',
        id: 202
    },
    {
        name: 'Asia/Choibalsan',
        displayName: 'GMT+08:00 चोइबालसन +08/+09',
        nameLocalized: 'चोइबालसन',
        abbreviationStandard: '+08/+09',
        id: 229
    },
    {
        name: 'Asia/Taipei',
        displayName: 'GMT+08:00 ताईपेई CST',
        nameLocalized: 'ताईपेई',
        abbreviationStandard: 'CST',
        id: 280,
        enabled: true
    },
    {
        name: 'Australia/Perth',
        displayName: 'GMT+08:00 पर्थ AWST',
        nameLocalized: 'पर्थ',
        abbreviationStandard: 'AWST',
        id: 324,
        enabled: true
    },
    {
        name: 'Asia/Brunei',
        displayName: 'GMT+08:00 ब्रूनेई +08',
        nameLocalized: 'ब्रूनेई',
        abbreviationStandard: '+08',
        id: 227
    },
    {
        name: 'Asia/Makassar',
        displayName: 'GMT+08:00 मकस्सर WITA',
        nameLocalized: 'मकस्सर',
        abbreviationStandard: 'WITA',
        id: 260
    },
    {
        name: 'Asia/Macau',
        displayName: 'GMT+08:00 मकाऊ CST',
        nameLocalized: 'मकाऊ',
        abbreviationStandard: 'CST',
        id: 258
    },
    {
        name: 'Asia/Manila',
        displayName: 'GMT+08:00 मनीला PST',
        nameLocalized: 'मनीला',
        abbreviationStandard: 'PST',
        id: 261
    },
    {
        name: 'Asia/Shanghai',
        displayName: 'GMT+08:00 शंघाई CST',
        nameLocalized: 'शंघाई',
        abbreviationStandard: 'CST',
        id: 278,
        enabled: true
    },
    {
        name: 'Asia/Singapore',
        displayName: 'GMT+08:00 सिंगापुर +08',
        nameLocalized: 'सिंगापुर',
        abbreviationStandard: '+08',
        id: 279
    },
    {
        name: 'Asia/Hong_Kong',
        displayName: 'GMT+08:00 हाँग काँग HKST',
        nameLocalized: 'हाँग काँग',
        abbreviationStandard: 'HKST',
        id: 241,
        enabled: true
    },
    {
        name: 'Asia/Chongqing',
        displayName: 'GMT+08:00 Chongqing CST',
        nameLocalized: 'Chongqing',
        abbreviationStandard: 'CST',
        id: 230
    },
    {
        name: 'Asia/Chungking',
        displayName: 'GMT+08:00 Chungking CST',
        nameLocalized: 'Chungking',
        abbreviationStandard: 'CST',
        id: 231
    },
    {
        name: 'Asia/Harbin',
        displayName: 'GMT+08:00 Harbin CST',
        nameLocalized: 'Harbin',
        abbreviationStandard: 'CST',
        id: 240
    },
    {
        name: 'Asia/Kashgar',
        displayName: 'GMT+08:00 Kashgar CST',
        nameLocalized: 'Kashgar',
        abbreviationStandard: 'CST',
        id: 251
    },
    {
        name: 'Asia/Ulan_Bator',
        displayName: 'GMT+08:00 Ulan Bator +08/+09',
        nameLocalized: 'Ulan Bator',
        abbreviationStandard: '+08/+09',
        id: 290
    },
    {
        name: 'Asia/Krasnoyarsk',
        displayName: 'GMT+07:00 क्रास्नोयार्स्क +07',
        nameLocalized: 'क्रास्नोयार्स्क',
        abbreviationStandard: '+07',
        id: 253,
        enabled: true
    },
    {
        name: 'Indian/Christmas',
        displayName: 'GMT+07:00 क्रिसमस +07',
        nameLocalized: 'क्रिसमस',
        abbreviationStandard: '+07',
        id: 461
    },
    {
        name: 'Asia/Jakarta',
        displayName: 'GMT+07:00 जकार्ता WIB',
        nameLocalized: 'जकार्ता',
        abbreviationStandard: 'WIB',
        id: 245
    },
    {
        name: 'Antarctica/Davis',
        displayName: 'GMT+07:00 डेविस +07',
        nameLocalized: 'डेविस',
        abbreviationStandard: '+07',
        id: 203
    },
    {
        name: 'Asia/Phnom_Penh',
        displayName: 'GMT+07:00 नॉम पेन्ह +07',
        nameLocalized: 'नॉम पेन्ह',
        abbreviationStandard: '+07',
        id: 267
    },
    {
        name: 'Asia/Novosibirsk',
        displayName: 'GMT+07:00 नोवोसिबिर्स्क +07',
        nameLocalized: 'नोवोसिबिर्स्क',
        abbreviationStandard: '+07',
        id: 264
    },
    {
        name: 'Asia/Pontianak',
        displayName: 'GMT+07:00 पोंटीयांक WIB',
        nameLocalized: 'पोंटीयांक',
        abbreviationStandard: 'WIB',
        id: 268
    },
    {
        name: 'Asia/Bangkok',
        displayName: 'GMT+07:00 बैंकॉक +07',
        nameLocalized: 'बैंकॉक',
        abbreviationStandard: '+07',
        id: 224,
        enabled: true
    },
    {
        name: 'Asia/Vientiane',
        displayName: 'GMT+07:00 विएनतियान +07',
        nameLocalized: 'विएनतियान',
        abbreviationStandard: '+07',
        id: 292
    },
    {
        name: 'Asia/Saigon',
        displayName: 'GMT+07:00 हो ची मिन्ह सिटी +07',
        nameLocalized: 'हो ची मिन्ह सिटी',
        abbreviationStandard: '+07',
        id: 274
    },
    {
        name: 'Asia/Hovd',
        displayName: 'GMT+07:00 होव्ड +07/+08',
        nameLocalized: 'होव्ड',
        abbreviationStandard: '+07/+08',
        id: 242
    },
    {
        name: 'Indian/Cocos',
        displayName: 'GMT+06:30 कोकोस +0630',
        nameLocalized: 'कोकोस',
        abbreviationStandard: '+0630',
        id: 462
    },
    {
        name: 'Asia/Urumqi',
        displayName: 'GMT+06:00 उरूम्की +06',
        nameLocalized: 'उरूम्की',
        abbreviationStandard: '+06',
        id: 291
    },
    {
        name: 'Asia/Omsk',
        displayName: 'GMT+06:00 ओम्स्क +06',
        nameLocalized: 'ओम्स्क',
        abbreviationStandard: '+06',
        id: 265
    },
    {
        name: 'Asia/Dhaka',
        displayName: 'GMT+06:00 ढाका +06/+07',
        nameLocalized: 'ढाका',
        abbreviationStandard: '+06/+07',
        id: 235,
        enabled: true
    },
    {
        name: 'Asia/Thimphu',
        displayName: 'GMT+06:00 थिंपू +06',
        nameLocalized: 'थिंपू',
        abbreviationStandard: '+06',
        id: 286
    },
    {
        name: 'Asia/Bishkek',
        displayName: 'GMT+06:00 बिश्केक +06',
        nameLocalized: 'बिश्केक',
        abbreviationStandard: '+06',
        id: 226
    },
    {
        name: 'Indian/Chagos',
        displayName: 'GMT+06:00 शागोस +06',
        nameLocalized: 'शागोस',
        abbreviationStandard: '+06',
        id: 460
    },
    {
        name: 'Asia/Colombo',
        displayName: 'GMT+05:30 कोलंबो +0530',
        nameLocalized: 'कोलंबो',
        abbreviationStandard: '+0530',
        id: 232,
        enabled: true
    },
    {
        name: 'Asia/Aqtau',
        displayName: 'GMT+05:00 अक्ताउ +05',
        nameLocalized: 'अक्ताउ',
        abbreviationStandard: '+05',
        id: 217
    },
    {
        name: 'Asia/Aqtobe',
        displayName: 'GMT+05:00 अक्तोब +05',
        nameLocalized: 'अक्तोब',
        abbreviationStandard: '+05',
        id: 218
    },
    {
        name: 'Asia/Almaty',
        displayName: 'GMT+05:00 अल्माटी +05',
        nameLocalized: 'अल्माटी',
        abbreviationStandard: '+05',
        id: 214,
        enabled: true
    },
    {
        name: 'Asia/Ashgabat',
        displayName: 'GMT+05:00 अश्गाबात +05',
        nameLocalized: 'अश्गाबात',
        abbreviationStandard: '+05',
        id: 219
    },
    {
        name: 'Asia/Oral',
        displayName: 'GMT+05:00 ओरल +05',
        nameLocalized: 'ओरल',
        abbreviationStandard: '+05',
        id: 266
    },
    {
        name: 'Indian/Kerguelen',
        displayName: 'GMT+05:00 करगुलेन +05',
        nameLocalized: 'करगुलेन',
        abbreviationStandard: '+05',
        id: 464
    },
    {
        name: 'Asia/Karachi',
        displayName: 'GMT+05:00 कराची PKST',
        nameLocalized: 'कराची',
        abbreviationStandard: 'PKST',
        id: 250,
        enabled: true
    },
    {
        name: 'Asia/Qyzylorda',
        displayName: 'GMT+05:00 केज़ेलोर्डा +05',
        nameLocalized: 'केज़ेलोर्डा',
        abbreviationStandard: '+05',
        id: 271
    },
    {
        name: 'Asia/Tashkent',
        displayName: 'GMT+05:00 ताशकंद +05',
        nameLocalized: 'ताशकंद',
        abbreviationStandard: '+05',
        id: 281
    },
    {
        name: 'Asia/Dushanbe',
        displayName: 'GMT+05:00 दुशांबे +05',
        nameLocalized: 'दुशांबे',
        abbreviationStandard: '+05',
        id: 238
    },
    {
        name: 'Indian/Maldives',
        displayName: 'GMT+05:00 मालदीव +05',
        nameLocalized: 'मालदीव',
        abbreviationStandard: '+05',
        id: 466
    },
    {
        name: 'Antarctica/Mawson',
        displayName: 'GMT+05:00 मॉसन +05',
        nameLocalized: 'मॉसन',
        abbreviationStandard: '+05',
        id: 205
    },
    {
        name: 'Asia/Yekaterinburg',
        displayName: 'GMT+05:00 येकातेरिनबर्ग +05',
        nameLocalized: 'येकातेरिनबर्ग',
        abbreviationStandard: '+05',
        id: 295,
        enabled: true
    },
    {
        name: 'Antarctica/Vostok',
        displayName: 'GMT+05:00 वोस्तोक +05',
        nameLocalized: 'वोस्तोक',
        abbreviationStandard: '+05',
        id: 211
    },
    {
        name: 'Asia/Samarkand',
        displayName: 'GMT+05:00 समरकंद +05',
        nameLocalized: 'समरकंद',
        abbreviationStandard: '+05',
        id: 276
    },
    {
        name: 'Asia/Kabul',
        displayName: 'GMT+04:30 काबुल +0430',
        nameLocalized: 'काबुल',
        abbreviationStandard: '+0430',
        id: 248,
        enabled: true
    },
    {
        name: 'Asia/Tbilisi',
        displayName: 'GMT+04:00 टबिलिसी +04',
        nameLocalized: 'टबिलिसी',
        abbreviationStandard: '+04',
        id: 282,
        enabled: true
    },
    {
        name: 'Asia/Dubai',
        displayName: 'GMT+04:00 दुबई +04',
        nameLocalized: 'दुबई',
        abbreviationStandard: '+04',
        id: 237
    },
    {
        name: 'Asia/Baku',
        displayName: 'GMT+04:00 बाकु +04/+05',
        nameLocalized: 'बाकु',
        abbreviationStandard: '+04/+05',
        id: 223,
        enabled: true
    },
    {
        name: 'Asia/Muscat',
        displayName: 'GMT+04:00 मस्कट +04',
        nameLocalized: 'मस्कट',
        abbreviationStandard: '+04',
        id: 262,
        enabled: true
    },
    {
        name: 'Indian/Mahe',
        displayName: 'GMT+04:00 माहे +04',
        nameLocalized: 'माहे',
        abbreviationStandard: '+04',
        id: 465
    },
    {
        name: 'Indian/Mauritius',
        displayName: 'GMT+04:00 मॉरीशस +04/+05',
        nameLocalized: 'मॉरीशस',
        abbreviationStandard: '+04/+05',
        id: 467
    },
    {
        name: 'Asia/Yerevan',
        displayName: 'GMT+04:00 येरेवान +04/+05',
        nameLocalized: 'येरेवान',
        abbreviationStandard: '+04/+05',
        id: 296,
        enabled: true
    },
    {
        name: 'Indian/Reunion',
        displayName: 'GMT+04:00 रीयूनियन +04',
        nameLocalized: 'रीयूनियन',
        abbreviationStandard: '+04',
        id: 469
    },
    {
        name: 'Europe/Samara',
        displayName: 'GMT+04:00 समारा +04',
        nameLocalized: 'समारा',
        abbreviationStandard: '+04',
        id: 428
    },
    {
        name: 'Asia/Tehran',
        displayName: 'GMT+03:30 तेहरान +0330/+0430',
        nameLocalized: 'तेहरान',
        abbreviationStandard: '+0330/+0430',
        id: 283,
        enabled: true
    },
    {
        name: 'Africa/Addis_Ababa',
        displayName: 'GMT+03:00 अदीस अबाबा EAT',
        nameLocalized: 'अदीस अबाबा',
        abbreviationStandard: 'EAT',
        id: 3
    },
    {
        name: 'Asia/Amman',
        displayName: 'GMT+03:00 अम्मान +03',
        nameLocalized: 'अम्मान',
        abbreviationStandard: '+03',
        id: 215,
        enabled: true
    },
    {
        name: 'Africa/Asmera',
        displayName: 'GMT+03:00 अस्मारा EAT',
        nameLocalized: 'अस्मारा',
        abbreviationStandard: 'EAT',
        id: 6
    },
    {
        name: 'Asia/Aden',
        displayName: 'GMT+03:00 आदेन +03',
        nameLocalized: 'आदेन',
        abbreviationStandard: '+03',
        id: 213
    },
    {
        name: 'Europe/Istanbul',
        displayName: 'GMT+03:00 इस्तांबुल +03',
        nameLocalized: 'इस्तांबुल',
        abbreviationStandard: '+03',
        id: 244,
        enabled: true
    },
    {
        name: 'Indian/Antananarivo',
        displayName: 'GMT+03:00 एंटानानरीवो EAT',
        nameLocalized: 'एंटानानरीवो',
        abbreviationStandard: 'EAT',
        id: 459
    },
    {
        name: 'Africa/Kampala',
        displayName: 'GMT+03:00 कंपाला EAT',
        nameLocalized: 'कंपाला',
        abbreviationStandard: 'EAT',
        id: 27
    },
    {
        name: 'Asia/Qatar',
        displayName: 'GMT+03:00 कतर +03',
        nameLocalized: 'कतर',
        abbreviationStandard: '+03',
        id: 270
    },
    {
        name: 'Asia/Kuwait',
        displayName: 'GMT+03:00 कुवैत +03',
        nameLocalized: 'कुवैत',
        abbreviationStandard: '+03',
        id: 256,
        enabled: true
    },
    {
        name: 'Indian/Comoro',
        displayName: 'GMT+03:00 कोमोरो EAT',
        nameLocalized: 'कोमोरो',
        abbreviationStandard: 'EAT',
        id: 463
    },
    {
        name: 'Africa/Djibouti',
        displayName: 'GMT+03:00 जिबूती EAT',
        nameLocalized: 'जिबूती',
        abbreviationStandard: 'EAT',
        id: 20
    },
    {
        name: 'Asia/Damascus',
        displayName: 'GMT+03:00 दमास्कस +03',
        nameLocalized: 'दमास्कस',
        abbreviationStandard: '+03',
        id: 234
    },
    {
        name: 'Africa/Dar_es_Salaam',
        displayName: 'GMT+03:00 दार अस सलाम EAT',
        nameLocalized: 'दार अस सलाम',
        abbreviationStandard: 'EAT',
        id: 19
    },
    {
        name: 'Africa/Nairobi',
        displayName: 'GMT+03:00 नैरोबी EAT',
        nameLocalized: 'नैरोबी',
        abbreviationStandard: 'EAT',
        id: 43,
        enabled: true
    },
    {
        name: 'Asia/Baghdad',
        displayName: 'GMT+03:00 बगदाद +03/+04',
        nameLocalized: 'बगदाद',
        abbreviationStandard: '+03/+04',
        id: 221,
        enabled: true
    },
    {
        name: 'Asia/Bahrain',
        displayName: 'GMT+03:00 बहरीन +03',
        nameLocalized: 'बहरीन',
        abbreviationStandard: '+03',
        id: 222
    },
    {
        name: 'Indian/Mayotte',
        displayName: 'GMT+03:00 मायोत्ते EAT',
        nameLocalized: 'मायोत्ते',
        abbreviationStandard: 'EAT',
        id: 468
    },
    {
        name: 'Europe/Minsk',
        displayName: 'GMT+03:00 मिंस्क +03',
        nameLocalized: 'मिंस्क',
        abbreviationStandard: '+03',
        id: 418,
        enabled: true
    },
    {
        name: 'Europe/Moscow',
        displayName: 'GMT+03:00 मॉस्को MSK',
        nameLocalized: 'मॉस्को',
        abbreviationStandard: 'MSK',
        id: 420,
        enabled: true
    },
    {
        name: 'Africa/Mogadishu',
        displayName: 'GMT+03:00 मोगादिशु EAT',
        nameLocalized: 'मोगादिशु',
        abbreviationStandard: 'EAT',
        id: 41
    },
    {
        name: 'Asia/Riyadh',
        displayName: 'GMT+03:00 रियाद +03',
        nameLocalized: 'रियाद',
        abbreviationStandard: '+03',
        id: 273
    },
    {
        name: 'Europe/Volgograd',
        displayName: 'GMT+03:00 वोल्गोग्राड MSK',
        nameLocalized: 'वोल्गोग्राड',
        abbreviationStandard: 'MSK',
        id: 443
    },
    {
        name: 'Europe/Simferopol',
        displayName: 'GMT+03:00 सिम्फ़ेरोपोल MSK',
        nameLocalized: 'सिम्फ़ेरोपोल',
        abbreviationStandard: 'MSK',
        id: 431
    },
    {
        name: 'Antarctica/Syowa',
        displayName: 'GMT+03:00 स्योवा +03',
        nameLocalized: 'स्योवा',
        abbreviationStandard: '+03',
        id: 210
    },
    {
        name: 'Africa/Asmara',
        displayName: 'GMT+03:00 Asmara EAT',
        nameLocalized: 'Asmara',
        abbreviationStandard: 'EAT',
        id: 5
    },
    {
        name: 'Asia/Istanbul',
        displayName: 'GMT+03:00 Istanbul +03',
        nameLocalized: 'Istanbul',
        abbreviationStandard: '+03',
        id: 407
    },
    {
        name: 'Europe/Tiraspol',
        displayName: 'GMT+03:00 Tiraspol MSK/MSD',
        nameLocalized: 'Tiraspol',
        abbreviationStandard: 'MSK/MSD',
        id: 437
    },
    {
        name: 'Europe/Athens',
        displayName: 'GMT+02:00 एथेंस EET',
        nameLocalized: 'एथेंस',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 392
    },
    {
        name: 'Africa/Mbabane',
        displayName: 'GMT+02:00 एमबाबेन SAST',
        nameLocalized: 'एमबाबेन',
        abbreviationStandard: 'SAST',
        id: 40
    },
    {
        name: 'Africa/Cairo',
        displayName: 'GMT+02:00 कायरो EET',
        nameLocalized: 'कायरो',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 14,
        enabled: true
    },
    {
        name: 'Europe/Kaliningrad',
        displayName: 'GMT+02:00 कालीनिनग्राड EET',
        nameLocalized: 'कालीनिनग्राड',
        abbreviationStandard: 'EET',
        id: 409
    },
    {
        name: 'Africa/Kigali',
        displayName: 'GMT+02:00 किगाली CAT',
        nameLocalized: 'किगाली',
        abbreviationStandard: 'CAT',
        id: 29
    },
    {
        name: 'Europe/Kiev',
        displayName: 'GMT+02:00 कीव EET',
        nameLocalized: 'कीव',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 410
    },
    {
        name: 'Africa/Khartoum',
        displayName: 'GMT+02:00 खार्तूम CAT',
        nameLocalized: 'खार्तूम',
        abbreviationStandard: 'CAT',
        id: 28
    },
    {
        name: 'Asia/Gaza',
        displayName: 'GMT+02:00 गाज़ा EET',
        nameLocalized: 'गाज़ा',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 239
    },
    {
        name: 'Africa/Gaborone',
        displayName: 'GMT+02:00 गाबोरोन CAT',
        nameLocalized: 'गाबोरोन',
        abbreviationStandard: 'CAT',
        id: 24
    },
    {
        name: 'Europe/Chisinau',
        displayName: 'GMT+02:00 चिसीनाउ EET',
        nameLocalized: 'चिसीनाउ',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 400
    },
    {
        name: 'Africa/Johannesburg',
        displayName: 'GMT+02:00 जोहांसबर्ग SAST',
        nameLocalized: 'जोहांसबर्ग',
        abbreviationStandard: 'SAST',
        id: 26
    },
    {
        name: 'Europe/Tallinn',
        displayName: 'GMT+02:00 तेलिन EET',
        nameLocalized: 'तेलिन',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 435
    },
    {
        name: 'Africa/Tripoli',
        displayName: 'GMT+02:00 त्रिपोली EET',
        nameLocalized: 'त्रिपोली',
        abbreviationStandard: 'EET',
        id: 51
    },
    {
        name: 'Asia/Nicosia',
        displayName: 'GMT+02:00 निकोसिया EET',
        nameLocalized: 'निकोसिया',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 263
    },
    {
        name: 'Europe/Bucharest',
        displayName: 'GMT+02:00 बुख़ारेस्ट EET',
        nameLocalized: 'बुख़ारेस्ट',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 398
    },
    {
        name: 'Africa/Bujumbura',
        displayName: 'GMT+02:00 बुजुंबूरा CAT',
        nameLocalized: 'बुजुंबूरा',
        abbreviationStandard: 'CAT',
        id: 13
    },
    {
        name: 'Asia/Beirut',
        displayName: 'GMT+02:00 बेरुत EET',
        nameLocalized: 'बेरुत',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 225,
        enabled: true
    },
    {
        name: 'Africa/Blantyre',
        displayName: 'GMT+02:00 ब्लांटायर CAT',
        nameLocalized: 'ब्लांटायर',
        abbreviationStandard: 'CAT',
        id: 11
    },
    {
        name: 'Africa/Maputo',
        displayName: 'GMT+02:00 मापुटो CAT',
        nameLocalized: 'मापुटो',
        abbreviationStandard: 'CAT',
        id: 38
    },
    {
        name: 'Europe/Mariehamn',
        displayName: 'GMT+02:00 मारियाहैम EET',
        nameLocalized: 'मारियाहैम',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 417
    },
    {
        name: 'Africa/Maseru',
        displayName: 'GMT+02:00 मासेरू SAST',
        nameLocalized: 'मासेरू',
        abbreviationStandard: 'SAST',
        id: 39
    },
    {
        name: 'Asia/Jerusalem',
        displayName: 'GMT+02:00 यरूशलम IST',
        nameLocalized: 'यरूशलम',
        abbreviationStandard: 'IST',
        abbreviationDaylight: 'IDT',
        id: 247,
        enabled: true
    },
    {
        name: 'Europe/Riga',
        displayName: 'GMT+02:00 रीगा EET',
        nameLocalized: 'रीगा',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 426
    },
    {
        name: 'Africa/Lubumbashi',
        displayName: 'GMT+02:00 लुबुमबाशी CAT',
        nameLocalized: 'लुबुमबाशी',
        abbreviationStandard: 'CAT',
        id: 35
    },
    {
        name: 'Africa/Lusaka',
        displayName: 'GMT+02:00 लुसाका CAT',
        nameLocalized: 'लुसाका',
        abbreviationStandard: 'CAT',
        id: 36
    },
    {
        name: 'Africa/Windhoek',
        displayName: 'GMT+02:00 विंडहोक WAT',
        nameLocalized: 'विंडहोक',
        abbreviationStandard: 'WAT',
        id: 53,
        enabled: true
    },
    {
        name: 'Europe/Vilnius',
        displayName: 'GMT+02:00 विल्नियस EET',
        nameLocalized: 'विल्नियस',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 442
    },
    {
        name: 'Europe/Sofia',
        displayName: 'GMT+02:00 सोफ़िया EET',
        nameLocalized: 'सोफ़िया',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 433
    },
    {
        name: 'Africa/Harare',
        displayName: 'GMT+02:00 हरारे CAT',
        nameLocalized: 'हरारे',
        abbreviationStandard: 'CAT',
        id: 25,
        enabled: true
    },
    {
        name: 'Europe/Helsinki',
        displayName: 'GMT+02:00 हेलसिंकी EET',
        nameLocalized: 'हेलसिंकी',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 405,
        enabled: true
    },
    {
        name: 'EET',
        displayName: 'GMT+02:00 EET EET',
        nameLocalized: 'EET',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 350
    },
    {
        name: 'Europe/Nicosia',
        displayName: 'GMT+02:00 Nicosia EET',
        nameLocalized: 'Nicosia',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 421
    },
    {
        name: 'Asia/Tel_Aviv',
        displayName: 'GMT+02:00 Tel Aviv IST',
        nameLocalized: 'Tel Aviv',
        abbreviationStandard: 'IST',
        abbreviationDaylight: 'IDT',
        id: 284
    },
    {
        name: 'Europe/Uzhgorod',
        displayName: 'GMT+02:00 Uzhgorod EET',
        nameLocalized: 'Uzhgorod',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 438
    },
    {
        name: 'Europe/Zaporozhye',
        displayName: 'GMT+02:00 Zaporozhye EET',
        nameLocalized: 'Zaporozhye',
        abbreviationStandard: 'EET',
        abbreviationDaylight: 'EEST',
        id: 446
    },
    {
        name: 'Europe/Andorra',
        displayName: 'GMT+01:00 अंडोरा CET',
        nameLocalized: 'अंडोरा',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 391
    },
    {
        name: 'Africa/El_Aaiun',
        displayName: 'GMT+01:00 अल आइयून +01/+00',
        nameLocalized: 'अल आइयून',
        abbreviationStandard: '+01/+00',
        id: 22
    },
    {
        name: 'Africa/Algiers',
        displayName: 'GMT+01:00 अल्जीयर्स CET',
        nameLocalized: 'अल्जीयर्स',
        abbreviationStandard: 'CET',
        id: 4
    },
    {
        name: 'Europe/Amsterdam',
        displayName: 'GMT+01:00 एम्स्टर्डम CET',
        nameLocalized: 'एम्स्टर्डम',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 390,
        enabled: true
    },
    {
        name: 'Europe/Oslo',
        displayName: 'GMT+01:00 ओस्लो CET',
        nameLocalized: 'ओस्लो',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 422
    },
    {
        name: 'Africa/Casablanca',
        displayName: 'GMT+01:00 कासाब्लांका +01/+00',
        nameLocalized: 'कासाब्लांका',
        abbreviationStandard: '+01/+00',
        id: 15,
        enabled: true
    },
    {
        name: 'Africa/Kinshasa',
        displayName: 'GMT+01:00 किंशासा WAT',
        nameLocalized: 'किंशासा',
        abbreviationStandard: 'WAT',
        id: 30
    },
    {
        name: 'Europe/Copenhagen',
        displayName: 'GMT+01:00 कोपेनहेगन CET',
        nameLocalized: 'कोपेनहेगन',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 401
    },
    {
        name: 'Europe/Zagreb',
        displayName: 'GMT+01:00 ज़ाग्रेब CET',
        nameLocalized: 'ज़ाग्रेब',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 445
    },
    {
        name: 'Europe/Gibraltar',
        displayName: 'GMT+01:00 जिब्राल्टर CET',
        nameLocalized: 'जिब्राल्टर',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 403
    },
    {
        name: 'Europe/Zurich',
        displayName: 'GMT+01:00 ज़्यूरिख़ CET',
        nameLocalized: 'ज़्यूरिख़',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 447
    },
    {
        name: 'Europe/Tirane',
        displayName: 'GMT+01:00 टाइरेन CET',
        nameLocalized: 'टाइरेन',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 436
    },
    {
        name: 'Africa/Tunis',
        displayName: 'GMT+01:00 ट्यूनिस CEST',
        nameLocalized: 'ट्यूनिस',
        abbreviationStandard: 'CEST',
        id: 52
    },
    {
        name: 'Europe/Dublin',
        displayName: 'GMT+01:00 डबलिन IST/GMT',
        nameLocalized: 'डबलिन',
        abbreviationStandard: 'IST/GMT',
        id: 402
    },
    {
        name: 'Africa/Douala',
        displayName: 'GMT+01:00 डूआला WAT',
        nameLocalized: 'डूआला',
        abbreviationStandard: 'WAT',
        id: 21
    },
    {
        name: 'Africa/Niamey',
        displayName: 'GMT+01:00 नियामी WAT',
        nameLocalized: 'नियामी',
        abbreviationStandard: 'WAT',
        id: 45
    },
    {
        name: 'Africa/Ndjamena',
        displayName: 'GMT+01:00 नेद्जामीना WAT',
        nameLocalized: 'नेद्जामीना',
        abbreviationStandard: 'WAT',
        id: 44
    },
    {
        name: 'Europe/Paris',
        displayName: 'GMT+01:00 पेरिस CET',
        nameLocalized: 'पेरिस',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 423
    },
    {
        name: 'Europe/Podgorica',
        displayName: 'GMT+01:00 पोड्गोरिका CET',
        nameLocalized: 'पोड्गोरिका',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 424
    },
    {
        name: 'Africa/Porto-Novo',
        displayName: 'GMT+01:00 पोर्टो-नोवो WAT',
        nameLocalized: 'पोर्टो-नोवो',
        abbreviationStandard: 'WAT',
        id: 48,
        enabled: true
    },
    {
        name: 'Europe/Prague',
        displayName: 'GMT+01:00 प्राग CET',
        nameLocalized: 'प्राग',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 425
    },
    {
        name: 'Europe/Berlin',
        displayName: 'GMT+01:00 बर्लिन CET',
        nameLocalized: 'बर्लिन',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 395
    },
    {
        name: 'Africa/Bangui',
        displayName: 'GMT+01:00 बांगुइ WAT',
        nameLocalized: 'बांगुइ',
        abbreviationStandard: 'WAT',
        id: 8
    },
    {
        name: 'Europe/Budapest',
        displayName: 'GMT+01:00 बुडापेस्ट CET',
        nameLocalized: 'बुडापेस्ट',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 399,
        enabled: true
    },
    {
        name: 'Europe/Belgrade',
        displayName: 'GMT+01:00 बेलग्रेड CET',
        nameLocalized: 'बेलग्रेड',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 394
    },
    {
        name: 'Africa/Brazzaville',
        displayName: 'GMT+01:00 ब्राज़ाविले WAT',
        nameLocalized: 'ब्राज़ाविले',
        abbreviationStandard: 'WAT',
        id: 12
    },
    {
        name: 'Europe/Bratislava',
        displayName: 'GMT+01:00 ब्रातिस्लावा CET',
        nameLocalized: 'ब्रातिस्लावा',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 396
    },
    {
        name: 'Europe/Brussels',
        displayName: 'GMT+01:00 ब्रूसेल्स CET',
        nameLocalized: 'ब्रूसेल्स',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 397
    },
    {
        name: 'Africa/Malabo',
        displayName: 'GMT+01:00 मलाबो WAT',
        nameLocalized: 'मलाबो',
        abbreviationStandard: 'WAT',
        id: 37
    },
    {
        name: 'Europe/Malta',
        displayName: 'GMT+01:00 माल्टा CET',
        nameLocalized: 'माल्टा',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 416
    },
    {
        name: 'Europe/Madrid',
        displayName: 'GMT+01:00 मैड्रिड CET',
        nameLocalized: 'मैड्रिड',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 415,
        enabled: true
    },
    {
        name: 'Europe/Monaco',
        displayName: 'GMT+01:00 मोनाको CET',
        nameLocalized: 'मोनाको',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 419
    },
    {
        name: 'Europe/Rome',
        displayName: 'GMT+01:00 रोम CET',
        nameLocalized: 'रोम',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 427
    },
    {
        name: 'Europe/Luxembourg',
        displayName: 'GMT+01:00 लक्ज़मबर्ग CET',
        nameLocalized: 'लक्ज़मबर्ग',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 414
    },
    {
        name: 'Africa/Lagos',
        displayName: 'GMT+01:00 लागोस WAT',
        nameLocalized: 'लागोस',
        abbreviationStandard: 'WAT',
        id: 31
    },
    {
        name: 'Africa/Libreville',
        displayName: 'GMT+01:00 लिब्रेविले WAT',
        nameLocalized: 'लिब्रेविले',
        abbreviationStandard: 'WAT',
        id: 32
    },
    {
        name: 'Africa/Luanda',
        displayName: 'GMT+01:00 लुआंडा WAT',
        nameLocalized: 'लुआंडा',
        abbreviationStandard: 'WAT',
        id: 34
    },
    {
        name: 'Arctic/Longyearbyen',
        displayName: 'GMT+01:00 लॉन्गईयरबायेन CET',
        nameLocalized: 'लॉन्गईयरबायेन',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 212
    },
    {
        name: 'Europe/Ljubljana',
        displayName: 'GMT+01:00 ल्यूबेलजाना CET',
        nameLocalized: 'ल्यूबेलजाना',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 412
    },
    {
        name: 'Europe/Vaduz',
        displayName: 'GMT+01:00 वादुज़ CET',
        nameLocalized: 'वादुज़',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 439
    },
    {
        name: 'Europe/Vienna',
        displayName: 'GMT+01:00 विएना CET',
        nameLocalized: 'विएना',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 441
    },
    {
        name: 'Europe/Vatican',
        displayName: 'GMT+01:00 वेटिकन CET',
        nameLocalized: 'वेटिकन',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 440
    },
    {
        name: 'Europe/Warsaw',
        displayName: 'GMT+01:00 वॉरसॉ CET',
        nameLocalized: 'वॉरसॉ',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 444
    },
    {
        name: 'Europe/Sarajevo',
        displayName: 'GMT+01:00 साराजेवो CET',
        nameLocalized: 'साराजेवो',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 430,
        enabled: true
    },
    {
        name: 'Africa/Ceuta',
        displayName: 'GMT+01:00 सेउटा CET',
        nameLocalized: 'सेउटा',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 16
    },
    {
        name: 'Europe/San_Marino',
        displayName: 'GMT+01:00 सैन मारीनो CET',
        nameLocalized: 'सैन मारीनो',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 429
    },
    {
        name: 'Europe/Skopje',
        displayName: 'GMT+01:00 स्कोप्जे CET',
        nameLocalized: 'स्कोप्जे',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 432
    },
    {
        name: 'Europe/Stockholm',
        displayName: 'GMT+01:00 स्टॉकहोम CET',
        nameLocalized: 'स्टॉकहोम',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 434
    },
    {
        name: 'CET',
        displayName: 'GMT+01:00 CET CET',
        nameLocalized: 'CET',
        abbreviationStandard: 'CET',
        abbreviationDaylight: 'CEST',
        id: 345
    },
    {
        name: 'MET',
        displayName: 'GMT+01:00 MET MET',
        nameLocalized: 'MET',
        abbreviationStandard: 'MET',
        abbreviationDaylight: 'MEST',
        id: 476
    },
    {
        name: 'Africa/Abidjan',
        displayName: 'GMT+00:00 अबिदजान GMT',
        nameLocalized: 'अबिदजान',
        abbreviationStandard: 'GMT',
        id: 1
    },
    {
        name: 'Europe/Isle_of_Man',
        displayName: 'GMT+00:00 आइल ऑफ़ मैन GMT/BST',
        nameLocalized: 'आइल ऑफ़ मैन',
        abbreviationStandard: 'GMT/BST',
        abbreviationDaylight: 'GMT/BST',
        id: 406
    },
    {
        name: 'Pacific/Enderbury',
        displayName: 'GMT+00:00 एंडरबरी -00',
        nameLocalized: 'एंडरबरी',
        abbreviationStandard: '-00',
        id: 490
    },
    {
        name: 'Africa/Accra',
        displayName: 'GMT+00:00 एक्रा GMT',
        nameLocalized: 'एक्रा',
        abbreviationStandard: 'GMT',
        id: 2
    },
    {
        name: 'Africa/Ouagadougou',
        displayName: 'GMT+00:00 औगाडोगू GMT',
        nameLocalized: 'औगाडोगू',
        abbreviationStandard: 'GMT',
        id: 47
    },
    {
        name: 'Asia/Katmandu',
        displayName: 'GMT+00:00 काठमांडू UTC',
        nameLocalized: 'काठमांडू',
        abbreviationStandard: 'UTC',
        id: 252,
        enabled: true
    },
    {
        name: 'Atlantic/Canary',
        displayName: 'GMT+00:00 कैनेरी WET',
        nameLocalized: 'कैनेरी',
        abbreviationStandard: 'WET',
        abbreviationDaylight: 'WEST',
        id: 299
    },
    {
        name: 'Africa/Conakry',
        displayName: 'GMT+00:00 कोनाक्री GMT',
        nameLocalized: 'कोनाक्री',
        abbreviationStandard: 'GMT',
        id: 17
    },
    {
        name: 'Asia/Calcutta',
        displayName: 'GMT+00:00 कोलकाता UTC',
        nameLocalized: 'कोलकाता',
        abbreviationStandard: 'UTC',
        id: 228,
        enabled: true
    },
    {
        name: 'Europe/Guernsey',
        displayName: 'GMT+00:00 गर्नसी GMT/BST',
        nameLocalized: 'गर्नसी',
        abbreviationStandard: 'GMT/BST',
        abbreviationDaylight: 'GMT/BST',
        id: 404
    },
    {
        name: 'Europe/Jersey',
        displayName: 'GMT+00:00 जर्सी GMT/BST',
        nameLocalized: 'जर्सी',
        abbreviationStandard: 'GMT/BST',
        abbreviationDaylight: 'GMT/BST',
        id: 408
    },
    {
        name: 'Africa/Dakar',
        displayName: 'GMT+00:00 डकार GMT',
        nameLocalized: 'डकार',
        abbreviationStandard: 'GMT',
        id: 18
    },
    {
        name: 'America/Danmarkshavn',
        displayName: 'GMT+00:00 डेनमार्कशॉन GMT',
        nameLocalized: 'डेनमार्कशॉन',
        abbreviationStandard: 'GMT',
        id: 97
    },
    {
        name: 'Africa/Nouakchott',
        displayName: 'GMT+00:00 नौआकशॉट GMT',
        nameLocalized: 'नौआकशॉट',
        abbreviationStandard: 'GMT',
        id: 46
    },
    {
        name: 'Atlantic/Faeroe',
        displayName: 'GMT+00:00 फ़ैरो UTC',
        nameLocalized: 'फ़ैरो',
        abbreviationStandard: 'UTC',
        id: 301
    },
    {
        name: 'Africa/Freetown',
        displayName: 'GMT+00:00 फ़्रीटाउन GMT',
        nameLocalized: 'फ़्रीटाउन',
        abbreviationStandard: 'GMT',
        id: 23
    },
    {
        name: 'Africa/Bamako',
        displayName: 'GMT+00:00 बामाको GMT',
        nameLocalized: 'बामाको',
        abbreviationStandard: 'GMT',
        id: 7
    },
    {
        name: 'Africa/Bissau',
        displayName: 'GMT+00:00 बिसाऊ GMT',
        nameLocalized: 'बिसाऊ',
        abbreviationStandard: 'GMT',
        id: 10
    },
    {
        name: 'Africa/Banjul',
        displayName: 'GMT+00:00 बैंजुल GMT',
        nameLocalized: 'बैंजुल',
        abbreviationStandard: 'GMT',
        id: 9
    },
    {
        name: 'Atlantic/Madeira',
        displayName: 'GMT+00:00 मडेरा WET',
        nameLocalized: 'मडेरा',
        abbreviationStandard: 'WET',
        abbreviationDaylight: 'WEST',
        id: 304
    },
    {
        name: 'Africa/Monrovia',
        displayName: 'GMT+00:00 मोनरोविया GMT',
        nameLocalized: 'मोनरोविया',
        abbreviationStandard: 'GMT',
        id: 42
    },
    {
        name: 'Asia/Rangoon',
        displayName: 'GMT+00:00 रंगून UTC',
        nameLocalized: 'रंगून',
        abbreviationStandard: 'UTC',
        id: 272,
        enabled: true
    },
    {
        name: 'Atlantic/Reykjavik',
        displayName: 'GMT+00:00 रेक्याविक GMT',
        nameLocalized: 'रेक्याविक',
        abbreviationStandard: 'GMT',
        id: 305
    },
    {
        name: 'Europe/London',
        displayName: 'GMT+00:00 लंदन GMT/BST',
        nameLocalized: 'लंदन',
        abbreviationStandard: 'GMT/BST',
        abbreviationDaylight: 'GMT/BST',
        id: 413,
        enabled: true
    },
    {
        name: 'Europe/Lisbon',
        displayName: 'GMT+00:00 लिस्बन WET',
        nameLocalized: 'लिस्बन',
        abbreviationStandard: 'WET',
        abbreviationDaylight: 'WEST',
        id: 411
    },
    {
        name: 'Africa/Lome',
        displayName: 'GMT+00:00 लोम GMT',
        nameLocalized: 'लोम',
        abbreviationStandard: 'GMT',
        id: 33
    },
    {
        name: 'Africa/Sao_Tome',
        displayName: 'GMT+00:00 साओ टोम GMT',
        nameLocalized: 'साओ टोम',
        abbreviationStandard: 'GMT',
        id: 49
    },
    {
        name: 'Atlantic/St_Helena',
        displayName: 'GMT+00:00 सेंट हेलेना GMT',
        nameLocalized: 'सेंट हेलेना',
        abbreviationStandard: 'GMT',
        id: 307
    },
    {
        name: 'US/Aleutian',
        displayName: 'GMT+00:00 Aleutian UTC',
        nameLocalized: 'Aleutian',
        abbreviationStandard: 'UTC',
        id: 536
    },
    {
        name: 'US/Arizona',
        displayName: 'GMT+00:00 Arizona UTC',
        nameLocalized: 'Arizona',
        abbreviationStandard: 'UTC',
        id: 537
    },
    {
        name: 'Asia/Ashkhabad',
        displayName: 'GMT+00:00 Ashkhabad UTC',
        nameLocalized: 'Ashkhabad',
        abbreviationStandard: 'UTC',
        id: 220
    },
    {
        name: 'America/Atka',
        displayName: 'GMT+00:00 Atka UTC',
        nameLocalized: 'Atka',
        abbreviationStandard: 'UTC',
        id: 73
    },
    {
        name: 'Canada/Atlantic',
        displayName: 'GMT+00:00 Atlantic UTC',
        nameLocalized: 'Atlantic',
        abbreviationStandard: 'UTC',
        id: 336
    },
    {
        name: 'Mexico/BajaNorte',
        displayName: 'GMT+00:00 BajaNorte UTC',
        nameLocalized: 'BajaNorte',
        abbreviationStandard: 'UTC',
        id: 477
    },
    {
        name: 'Europe/Belfast',
        displayName: 'GMT+00:00 Belfast GMT/BST',
        nameLocalized: 'Belfast',
        abbreviationStandard: 'GMT/BST',
        abbreviationDaylight: 'GMT/BST',
        id: 393
    },
    {
        name: 'US/Central',
        displayName: 'GMT+00:00 Central UTC',
        nameLocalized: 'Central',
        abbreviationStandard: 'UTC',
        id: 538
    },
    {
        name: 'Cuba',
        displayName: 'GMT+00:00 Cuba UTC',
        nameLocalized: 'Cuba',
        abbreviationStandard: 'UTC',
        id: 349
    },
    {
        name: 'Asia/Dacca',
        displayName: 'GMT+00:00 Dacca UTC',
        nameLocalized: 'Dacca',
        abbreviationStandard: 'UTC',
        id: 233
    },
    {
        name: 'Brazil/DeNoronha',
        displayName: 'GMT+00:00 DeNoronha UTC',
        nameLocalized: 'DeNoronha',
        abbreviationStandard: 'UTC',
        id: 333
    },
    {
        name: 'Canada/East-Saskatchewan',
        displayName: 'GMT+00:00 East-Saskatchewan UTC',
        nameLocalized: 'East-Saskatchewan',
        abbreviationStandard: 'UTC',
        id: 338
    },
    {
        name: 'Chile/EasterIsland',
        displayName: 'GMT+00:00 EasterIsland UTC',
        nameLocalized: 'EasterIsland',
        abbreviationStandard: 'UTC',
        id: 347
    },
    {
        name: 'Canada/Eastern',
        displayName: 'GMT+00:00 Eastern UTC',
        nameLocalized: 'Eastern',
        abbreviationStandard: 'UTC',
        id: 339
    },
    {
        name: 'Egypt',
        displayName: 'GMT+00:00 Egypt UTC',
        nameLocalized: 'Egypt',
        abbreviationStandard: 'UTC',
        id: 351
    },
    {
        name: 'Eire',
        displayName: 'GMT+00:00 Eire UTC',
        nameLocalized: 'Eire',
        abbreviationStandard: 'UTC',
        id: 352
    },
    {
        name: 'Factory',
        displayName: 'GMT+00:00 Factory -00',
        nameLocalized: 'Factory',
        abbreviationStandard: '-00',
        id: 448
    },
    {
        name: 'Atlantic/Faroe',
        displayName: 'GMT+00:00 Faroe WET',
        nameLocalized: 'Faroe',
        abbreviationStandard: 'WET',
        abbreviationDaylight: 'WEST',
        id: 302
    },
    {
        name: 'GB',
        displayName: 'GMT+00:00 GB UTC',
        nameLocalized: 'GB',
        abbreviationStandard: 'UTC',
        id: 449
    },
    {
        name: 'GB-Eire',
        displayName: 'GMT+00:00 GB-Eire UTC',
        nameLocalized: 'GB-Eire',
        abbreviationStandard: 'UTC',
        id: 450
    },
    {
        name: 'Etc/GMT',
        displayName: 'GMT+00:00 GMT GMT',
        nameLocalized: 'GMT',
        abbreviationStandard: 'GMT',
        id: 355
    },
    {
        name: 'GMT',
        displayName: 'GMT+00:00 GMT UTC',
        nameLocalized: 'GMT',
        abbreviationStandard: 'UTC',
        id: 451
    },
    {
        name: 'Etc/GMT-0',
        displayName: 'GMT+00:00 GMT-0 UTC',
        nameLocalized: 'GMT-0',
        abbreviationStandard: 'UTC',
        id: 369
    },
    {
        name: 'GMT-0',
        displayName: 'GMT+00:00 GMT-0 UTC',
        nameLocalized: 'GMT-0',
        abbreviationStandard: 'UTC',
        id: 453
    },
    {
        name: 'Etc/GMT+0',
        displayName: 'GMT+00:00 GMT+0 UTC',
        nameLocalized: 'GMT+0',
        abbreviationStandard: 'UTC',
        id: 356
    },
    {
        name: 'GMT+0',
        displayName: 'GMT+00:00 GMT+0 UTC',
        nameLocalized: 'GMT+0',
        abbreviationStandard: 'UTC',
        id: 452
    },
    {
        name: 'Etc/GMT0',
        displayName: 'GMT+00:00 GMT0 UTC',
        nameLocalized: 'GMT0',
        abbreviationStandard: 'UTC',
        id: 384
    },
    {
        name: 'GMT0',
        displayName: 'GMT+00:00 GMT0 UTC',
        nameLocalized: 'GMT0',
        abbreviationStandard: 'UTC',
        id: 454
    },
    {
        name: 'Etc/Greenwich',
        displayName: 'GMT+00:00 Greenwich UTC',
        nameLocalized: 'Greenwich',
        abbreviationStandard: 'UTC',
        id: 385
    },
    {
        name: 'Greenwich',
        displayName: 'GMT+00:00 Greenwich UTC',
        nameLocalized: 'Greenwich',
        abbreviationStandard: 'UTC',
        id: 455
    },
    {
        name: 'Hongkong',
        displayName: 'GMT+00:00 Hongkong UTC',
        nameLocalized: 'Hongkong',
        abbreviationStandard: 'UTC',
        id: 456
    },
    {
        name: 'Iceland',
        displayName: 'GMT+00:00 Iceland GMT',
        nameLocalized: 'Iceland',
        abbreviationStandard: 'GMT',
        id: 458
    },
    {
        name: 'Iran',
        displayName: 'GMT+00:00 Iran UTC',
        nameLocalized: 'Iran',
        abbreviationStandard: 'UTC',
        id: 470
    },
    {
        name: 'Israel',
        displayName: 'GMT+00:00 Israel UTC',
        nameLocalized: 'Israel',
        abbreviationStandard: 'UTC',
        id: 471
    },
    {
        name: 'Jamaica',
        displayName: 'GMT+00:00 Jamaica UTC',
        nameLocalized: 'Jamaica',
        abbreviationStandard: 'UTC',
        id: 472
    },
    {
        name: 'Japan',
        displayName: 'GMT+00:00 Japan UTC',
        nameLocalized: 'Japan',
        abbreviationStandard: 'UTC',
        id: 473
    },
    {
        name: 'Libya',
        displayName: 'GMT+00:00 Libya UTC',
        nameLocalized: 'Libya',
        abbreviationStandard: 'UTC',
        id: 475
    },
    {
        name: 'Asia/Macao',
        displayName: 'GMT+00:00 Macao UTC',
        nameLocalized: 'Macao',
        abbreviationStandard: 'UTC',
        id: 257
    },
    {
        name: 'US/Michigan',
        displayName: 'GMT+00:00 Michigan UTC',
        nameLocalized: 'Michigan',
        abbreviationStandard: 'UTC',
        id: 543
    },
    {
        name: 'US/Mountain',
        displayName: 'GMT+00:00 Mountain UTC',
        nameLocalized: 'Mountain',
        abbreviationStandard: 'UTC',
        id: 544
    },
    {
        name: 'Navajo',
        displayName: 'GMT+00:00 Navajo UTC',
        nameLocalized: 'Navajo',
        abbreviationStandard: 'UTC',
        id: 482
    },
    {
        name: 'NZ-CHAT',
        displayName: 'GMT+00:00 NZ-CHAT UTC',
        nameLocalized: 'NZ-CHAT',
        abbreviationStandard: 'UTC',
        id: 484
    },
    {
        name: 'US/Pacific-New',
        displayName: 'GMT+00:00 Pacific-New UTC',
        nameLocalized: 'Pacific-New',
        abbreviationStandard: 'UTC',
        id: 546
    },
    {
        name: 'Poland',
        displayName: 'GMT+00:00 Poland UTC',
        nameLocalized: 'Poland',
        abbreviationStandard: 'UTC',
        id: 525
    },
    {
        name: 'Portugal',
        displayName: 'GMT+00:00 Portugal UTC',
        nameLocalized: 'Portugal',
        abbreviationStandard: 'UTC',
        id: 526
    },
    {
        name: 'PRC',
        displayName: 'GMT+00:00 PRC UTC',
        nameLocalized: 'PRC',
        abbreviationStandard: 'UTC',
        id: 527
    },
    {
        name: 'ROC',
        displayName: 'GMT+00:00 ROC UTC',
        nameLocalized: 'ROC',
        abbreviationStandard: 'UTC',
        id: 529
    },
    {
        name: 'ROK',
        displayName: 'GMT+00:00 ROK UTC',
        nameLocalized: 'ROK',
        abbreviationStandard: 'UTC',
        id: 530
    },
    {
        name: 'Canada/Saskatchewan',
        displayName: 'GMT+00:00 Saskatchewan UTC',
        nameLocalized: 'Saskatchewan',
        abbreviationStandard: 'UTC',
        id: 343,
        enabled: true
    },
    {
        name: 'America/Shiprock',
        displayName: 'GMT+00:00 Shiprock UTC',
        nameLocalized: 'Shiprock',
        abbreviationStandard: 'UTC',
        id: 183
    },
    {
        name: 'Singapore',
        displayName: 'GMT+00:00 Singapore UTC',
        nameLocalized: 'Singapore',
        abbreviationStandard: 'UTC',
        id: 531
    },
    {
        name: 'Asia/Thimbu',
        displayName: 'GMT+00:00 Thimbu UTC',
        nameLocalized: 'Thimbu',
        abbreviationStandard: 'UTC',
        id: 285
    },
    {
        name: 'Africa/Timbuktu',
        displayName: 'GMT+00:00 Timbuktu GMT',
        nameLocalized: 'Timbuktu',
        abbreviationStandard: 'GMT',
        id: 50
    },
    {
        name: 'Turkey',
        displayName: 'GMT+00:00 Turkey UTC',
        nameLocalized: 'Turkey',
        abbreviationStandard: 'UTC',
        id: 532
    },
    {
        name: 'Etc/UCT',
        displayName: 'GMT+00:00 UCT UTC',
        nameLocalized: 'UCT',
        abbreviationStandard: 'UTC',
        id: 386
    },
    {
        name: 'UCT',
        displayName: 'GMT+00:00 UCT UTC',
        nameLocalized: 'UCT',
        abbreviationStandard: 'UTC',
        id: 533
    },
    {
        name: 'Asia/Ujung_Pandang',
        displayName: 'GMT+00:00 Ujung Pandang UTC',
        nameLocalized: 'Ujung Pandang',
        abbreviationStandard: 'UTC',
        id: 288
    },
    {
        name: 'Etc/Universal',
        displayName: 'GMT+00:00 Universal UTC',
        nameLocalized: 'Universal',
        abbreviationStandard: 'UTC',
        id: 387
    },
    {
        name: 'Universal',
        displayName: 'GMT+00:00 Universal UTC',
        nameLocalized: 'Universal',
        abbreviationStandard: 'UTC',
        id: 534
    },
    {
        name: 'Etc/UTC',
        displayName: 'GMT+00:00 UTC UTC',
        nameLocalized: 'UTC',
        abbreviationStandard: 'UTC',
        id: 388
    },
    {
        name: 'UTC',
        displayName: 'GMT+00:00 UTC UTC',
        nameLocalized: 'UTC',
        abbreviationStandard: 'UTC',
        id: 548
    },
    {
        name: 'W-SU',
        displayName: 'GMT+00:00 W-SU UTC',
        nameLocalized: 'W-SU',
        abbreviationStandard: 'UTC',
        id: 549
    },
    {
        name: 'Australia/West',
        displayName: 'GMT+00:00 West UTC',
        nameLocalized: 'West',
        abbreviationStandard: 'UTC',
        id: 330
    },
    {
        name: 'Brazil/West',
        displayName: 'GMT+00:00 West UTC',
        nameLocalized: 'West',
        abbreviationStandard: 'UTC',
        id: 335
    },
    {
        name: 'WET',
        displayName: 'GMT+00:00 WET WET',
        nameLocalized: 'WET',
        abbreviationStandard: 'WET',
        abbreviationDaylight: 'WEST',
        id: 550
    },
    {
        name: 'Etc/Zulu',
        displayName: 'GMT+00:00 Zulu UTC',
        nameLocalized: 'Zulu',
        abbreviationStandard: 'UTC',
        id: 389
    },
    {
        name: 'Zulu',
        displayName: 'GMT+00:00 Zulu UTC',
        nameLocalized: 'Zulu',
        abbreviationStandard: 'UTC',
        id: 551,
        enabled: true
    },
    {
        name: 'Atlantic/Azores',
        displayName: 'GMT-01:00 अज़ोरेस -01/+00',
        nameLocalized: 'अज़ोरेस',
        abbreviationStandard: '-01/+00',
        abbreviationDaylight: '-01/+00',
        id: 297,
        enabled: true
    },
    {
        name: 'Atlantic/Cape_Verde',
        displayName: 'GMT-01:00 केप वर्ड -01',
        nameLocalized: 'केप वर्ड',
        abbreviationStandard: '-01',
        id: 300,
        enabled: true
    },
    {
        name: 'Etc/GMT-1',
        displayName: 'GMT-01:00 GMT-1 -01',
        nameLocalized: 'GMT-1',
        abbreviationStandard: '-01',
        id: 370
    },
    {
        name: 'Etc/GMT+1',
        displayName: 'GMT-01:00 GMT+1 -01',
        nameLocalized: 'GMT+1',
        abbreviationStandard: '-01',
        id: 357
    },
    {
        name: 'Atlantic/Jan_Mayen',
        displayName: 'GMT-01:00 Jan Mayen -01',
        nameLocalized: 'Jan Mayen',
        abbreviationStandard: '-01',
        id: 303
    },
    {
        name: 'America/Scoresbysund',
        displayName: 'GMT-02:00 इटोकोर्टोरमिट -02/-01',
        nameLocalized: 'इटोकोर्टोरमिट',
        abbreviationStandard: '-02/-01',
        abbreviationDaylight: '-02/-01',
        id: 182
    },
    {
        name: 'Atlantic/South_Georgia',
        displayName: 'GMT-02:00 दक्षिण जॉर्जिया -02',
        nameLocalized: 'दक्षिण जॉर्जिया',
        abbreviationStandard: '-02',
        id: 306,
        enabled: true
    },
    {
        name: 'America/Noronha',
        displayName: 'GMT-02:00 नोरोन्हा -02',
        nameLocalized: 'नोरोन्हा',
        abbreviationStandard: '-02',
        id: 160
    },
    {
        name: 'Etc/GMT-2',
        displayName: 'GMT-02:00 GMT-2 -02',
        nameLocalized: 'GMT-2',
        abbreviationStandard: '-02',
        id: 376
    },
    {
        name: 'Etc/GMT+2',
        displayName: 'GMT-02:00 GMT+2 -02',
        nameLocalized: 'GMT+2',
        abbreviationStandard: '-02',
        id: 361
    },
    {
        name: 'America/St_Johns',
        displayName: 'GMT-03:30 सेंट जोंस NST',
        nameLocalized: 'सेंट जोंस',
        abbreviationStandard: 'NST',
        abbreviationDaylight: 'NDT',
        id: 184,
        enabled: true
    },
    {
        name: 'Canada/Newfoundland',
        displayName: 'GMT-03:30 Newfoundland NST',
        nameLocalized: 'Newfoundland',
        abbreviationStandard: 'NST',
        abbreviationDaylight: 'NDT',
        id: 341
    },
    {
        name: 'America/Araguaina',
        displayName: 'GMT-03:00 आराग्वेना -03',
        nameLocalized: 'आराग्वेना',
        abbreviationStandard: '-03',
        id: 58
    },
    {
        name: 'America/Argentina/Ushuaia',
        displayName: 'GMT-03:00 उशुआइया -03',
        nameLocalized: 'उशुआइया',
        abbreviationStandard: '-03',
        id: 69
    },
    {
        name: 'America/Catamarca',
        displayName: 'GMT-03:00 काटामार्का -03',
        nameLocalized: 'काटामार्का',
        abbreviationStandard: '-03',
        id: 87
    },
    {
        name: 'America/Cayenne',
        displayName: 'GMT-03:00 कायेन -03',
        nameLocalized: 'कायेन',
        abbreviationStandard: '-03',
        id: 88
    },
    {
        name: 'America/Cordoba',
        displayName: 'GMT-03:00 कोर्डोबा -03/-02',
        nameLocalized: 'कोर्डोबा',
        abbreviationStandard: '-03/-02',
        id: 93
    },
    {
        name: 'America/Jujuy',
        displayName: 'GMT-03:00 जुजोए -03',
        nameLocalized: 'जुजोए',
        abbreviationStandard: '-03',
        id: 132
    },
    {
        name: 'America/Argentina/Tucuman',
        displayName: 'GMT-03:00 टोकूमन -03/-02',
        nameLocalized: 'टोकूमन',
        abbreviationStandard: '-03/-02',
        id: 68
    },
    {
        name: 'America/Godthab',
        displayName: 'GMT-03:00 नुक -03/-02',
        nameLocalized: 'नुक',
        abbreviationStandard: '-03/-02',
        abbreviationDaylight: '-03/-02',
        id: 110,
        enabled: true
    },
    {
        name: 'America/Paramaribo',
        displayName: 'GMT-03:00 पारामारिबो -03',
        nameLocalized: 'पारामारिबो',
        abbreviationStandard: '-03',
        id: 165
    },
    {
        name: 'Antarctica/Palmer',
        displayName: 'GMT-03:00 पॉमर -03',
        nameLocalized: 'पॉमर',
        abbreviationStandard: '-03',
        id: 207
    },
    {
        name: 'America/Fortaleza',
        displayName: 'GMT-03:00 फ़ोर्टालेज़ा -03',
        nameLocalized: 'फ़ोर्टालेज़ा',
        abbreviationStandard: '-03',
        id: 108
    },
    {
        name: 'America/Bahia',
        displayName: 'GMT-03:00 बहिया -03',
        nameLocalized: 'बहिया',
        abbreviationStandard: '-03',
        id: 74
    },
    {
        name: 'America/Belem',
        displayName: 'GMT-03:00 बेलेम -03',
        nameLocalized: 'बेलेम',
        abbreviationStandard: '-03',
        id: 76
    },
    {
        name: 'America/Buenos_Aires',
        displayName: 'GMT-03:00 ब्यूनस आयरस -03/-02',
        nameLocalized: 'ब्यूनस आयरस',
        abbreviationStandard: '-03/-02',
        id: 82,
        enabled: true
    },
    {
        name: 'America/Miquelon',
        displayName: 'GMT-03:00 मिकेलॉन -03/-02',
        nameLocalized: 'मिकेलॉन',
        abbreviationStandard: '-03/-02',
        abbreviationDaylight: '-03/-02',
        id: 150
    },
    {
        name: 'America/Mendoza',
        displayName: 'GMT-03:00 मेंडोज़ा -03',
        nameLocalized: 'मेंडोज़ा',
        abbreviationStandard: '-03',
        id: 146
    },
    {
        name: 'America/Maceio',
        displayName: 'GMT-03:00 मेसीओ -03',
        nameLocalized: 'मेसीओ',
        abbreviationStandard: '-03',
        id: 141
    },
    {
        name: 'America/Montevideo',
        displayName: 'GMT-03:00 मोंटेवीडियो -03/-02',
        nameLocalized: 'मोंटेवीडियो',
        abbreviationStandard: '-03/-02',
        id: 153,
        enabled: true
    },
    {
        name: 'America/Argentina/Rio_Gallegos',
        displayName: 'GMT-03:00 रियो गालेगोस -03',
        nameLocalized: 'रियो गालेगोस',
        abbreviationStandard: '-03',
        id: 66
    },
    {
        name: 'America/Recife',
        displayName: 'GMT-03:00 रेसाइफ़ -03',
        nameLocalized: 'रेसाइफ़',
        abbreviationStandard: '-03',
        id: 174
    },
    {
        name: 'Antarctica/Rothera',
        displayName: 'GMT-03:00 रोथेरा -03',
        nameLocalized: 'रोथेरा',
        abbreviationStandard: '-03',
        id: 208
    },
    {
        name: 'America/Argentina/La_Rioja',
        displayName: 'GMT-03:00 ला रिओजा -03',
        nameLocalized: 'ला रिओजा',
        abbreviationStandard: '-03',
        id: 64
    },
    {
        name: 'America/Sao_Paulo',
        displayName: 'GMT-03:00 साओ पाउलो -03/-02',
        nameLocalized: 'साओ पाउलो',
        abbreviationStandard: '-03/-02',
        id: 181,
        enabled: true
    },
    {
        name: 'America/Argentina/San_Juan',
        displayName: 'GMT-03:00 सैन ह्वान -03',
        nameLocalized: 'सैन ह्वान',
        abbreviationStandard: '-03',
        id: 67
    },
    {
        name: 'Atlantic/Stanley',
        displayName: 'GMT-03:00 स्टैनली -03',
        nameLocalized: 'स्टैनली',
        abbreviationStandard: '-03',
        id: 308
    },
    {
        name: 'America/Argentina/Buenos_Aires',
        displayName: 'GMT-03:00 Buenos Aires -03/-02',
        nameLocalized: 'Buenos Aires',
        abbreviationStandard: '-03/-02',
        id: 59
    },
    {
        name: 'America/Argentina/Catamarca',
        displayName: 'GMT-03:00 Catamarca -03',
        nameLocalized: 'Catamarca',
        abbreviationStandard: '-03',
        id: 60
    },
    {
        name: 'America/Argentina/ComodRivadavia',
        displayName: 'GMT-03:00 ComodRivadavia -03',
        nameLocalized: 'ComodRivadavia',
        abbreviationStandard: '-03',
        id: 61
    },
    {
        name: 'America/Argentina/Cordoba',
        displayName: 'GMT-03:00 Cordoba -03/-02',
        nameLocalized: 'Cordoba',
        abbreviationStandard: '-03/-02',
        id: 62
    },
    {
        name: 'Brazil/East',
        displayName: 'GMT-03:00 East -03/-02',
        nameLocalized: 'East',
        abbreviationStandard: '-03/-02',
        id: 334
    },
    {
        name: 'Etc/GMT-3',
        displayName: 'GMT-03:00 GMT-3 -03',
        nameLocalized: 'GMT-3',
        abbreviationStandard: '-03',
        id: 377
    },
    {
        name: 'Etc/GMT+3',
        displayName: 'GMT-03:00 GMT+3 -03',
        nameLocalized: 'GMT+3',
        abbreviationStandard: '-03',
        id: 362
    },
    {
        name: 'America/Argentina/Jujuy',
        displayName: 'GMT-03:00 Jujuy -03',
        nameLocalized: 'Jujuy',
        abbreviationStandard: '-03',
        id: 63
    },
    {
        name: 'America/Argentina/Mendoza',
        displayName: 'GMT-03:00 Mendoza -03',
        nameLocalized: 'Mendoza',
        abbreviationStandard: '-03',
        id: 65
    },
    {
        name: 'America/Rosario',
        displayName: 'GMT-03:00 Rosario -03/-02',
        nameLocalized: 'Rosario',
        abbreviationStandard: '-03/-02',
        id: 178
    },
    {
        name: 'America/Aruba',
        displayName: 'GMT-04:00 अरूबा AST',
        nameLocalized: 'अरूबा',
        abbreviationStandard: 'AST',
        id: 70
    },
    {
        name: 'America/Anguilla',
        displayName: 'GMT-04:00 एंग्विला AST',
        nameLocalized: 'एंग्विला',
        abbreviationStandard: 'AST',
        id: 56
    },
    {
        name: 'America/Antigua',
        displayName: 'GMT-04:00 एंटीगुआ AST',
        nameLocalized: 'एंटीगुआ',
        abbreviationStandard: 'AST',
        id: 57
    },
    {
        name: 'America/Asuncion',
        displayName: 'GMT-04:00 एसनशियॉन -04/-03',
        nameLocalized: 'एसनशियॉन',
        abbreviationStandard: '-04/-03',
        abbreviationDaylight: '-04/-03',
        id: 71
    },
    {
        name: 'America/Caracas',
        displayName: 'GMT-04:00 काराकस -04',
        nameLocalized: 'काराकस',
        abbreviationStandard: '-04',
        id: 86,
        enabled: true
    },
    {
        name: 'America/Curacao',
        displayName: 'GMT-04:00 कुराकाओ AST',
        nameLocalized: 'कुराकाओ',
        abbreviationStandard: 'AST',
        id: 96
    },
    {
        name: 'America/Campo_Grande',
        displayName: 'GMT-04:00 कैंपो ग्रांडे -04/-03',
        nameLocalized: 'कैंपो ग्रांडे',
        abbreviationStandard: '-04/-03',
        id: 84
    },
    {
        name: 'America/Cuiaba',
        displayName: 'GMT-04:00 क्यूआबा -04/-03',
        nameLocalized: 'क्यूआबा',
        abbreviationStandard: '-04/-03',
        id: 95
    },
    {
        name: 'America/Guyana',
        displayName: 'GMT-04:00 गयाना -04',
        nameLocalized: 'गयाना',
        abbreviationStandard: '-04',
        id: 117
    },
    {
        name: 'America/Goose_Bay',
        displayName: 'GMT-04:00 गूस खाड़ी AST',
        nameLocalized: 'गूस खाड़ी',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 111,
        enabled: true
    },
    {
        name: 'America/Grenada',
        displayName: 'GMT-04:00 ग्रेनाडा AST',
        nameLocalized: 'ग्रेनाडा',
        abbreviationStandard: 'AST',
        id: 113
    },
    {
        name: 'America/Glace_Bay',
        displayName: 'GMT-04:00 ग्लेस खाड़ी AST',
        nameLocalized: 'ग्लेस खाड़ी',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 109
    },
    {
        name: 'America/Guadeloupe',
        displayName: 'GMT-04:00 ग्वाडेलोप AST',
        nameLocalized: 'ग्वाडेलोप',
        abbreviationStandard: 'AST',
        id: 114
    },
    {
        name: 'America/Tortola',
        displayName: 'GMT-04:00 टोर्टोला AST',
        nameLocalized: 'टोर्टोला',
        abbreviationStandard: 'AST',
        id: 195
    },
    {
        name: 'America/Dominica',
        displayName: 'GMT-04:00 डोमिनिका AST',
        nameLocalized: 'डोमिनिका',
        abbreviationStandard: 'AST',
        id: 102
    },
    {
        name: 'America/Thule',
        displayName: 'GMT-04:00 थ्यूले AST',
        nameLocalized: 'थ्यूले',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 191
    },
    {
        name: 'America/Port_of_Spain',
        displayName: 'GMT-04:00 पोर्ट ऑफ़ स्पेन AST',
        nameLocalized: 'पोर्ट ऑफ़ स्पेन',
        abbreviationStandard: 'AST',
        id: 168
    },
    {
        name: 'America/Puerto_Rico',
        displayName: 'GMT-04:00 पोर्टो रिको AST',
        nameLocalized: 'पोर्टो रिको',
        abbreviationStandard: 'AST',
        id: 171
    },
    {
        name: 'America/Porto_Velho',
        displayName: 'GMT-04:00 पोर्टो वेल्हो -04',
        nameLocalized: 'पोर्टो वेल्हो',
        abbreviationStandard: '-04',
        id: 170
    },
    {
        name: 'Atlantic/Bermuda',
        displayName: 'GMT-04:00 बरमूडा AST',
        nameLocalized: 'बरमूडा',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 298
    },
    {
        name: 'America/Barbados',
        displayName: 'GMT-04:00 बारबाडोस AST',
        nameLocalized: 'बारबाडोस',
        abbreviationStandard: 'AST',
        id: 75
    },
    {
        name: 'America/Boa_Vista',
        displayName: 'GMT-04:00 बोआ विस्ता -04',
        nameLocalized: 'बोआ विस्ता',
        abbreviationStandard: '-04',
        id: 79
    },
    {
        name: 'America/Blanc-Sablon',
        displayName: 'GMT-04:00 ब्लांक-सेबलोन AST',
        nameLocalized: 'ब्लांक-सेबलोन',
        abbreviationStandard: 'AST',
        id: 78
    },
    {
        name: 'America/Manaus',
        displayName: 'GMT-04:00 मनौस -04',
        nameLocalized: 'मनौस',
        abbreviationStandard: '-04',
        id: 143,
        enabled: true
    },
    {
        name: 'America/Martinique',
        displayName: 'GMT-04:00 मार्टिनिक AST',
        nameLocalized: 'मार्टिनिक',
        abbreviationStandard: 'AST',
        id: 144
    },
    {
        name: 'America/Moncton',
        displayName: 'GMT-04:00 मोंकटन AST',
        nameLocalized: 'मोंकटन',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 151
    },
    {
        name: 'America/Montserrat',
        displayName: 'GMT-04:00 मोंटसेरात AST',
        nameLocalized: 'मोंटसेरात',
        abbreviationStandard: 'AST',
        id: 155
    },
    {
        name: 'America/La_Paz',
        displayName: 'GMT-04:00 ला पाज़ -04',
        nameLocalized: 'ला पाज़',
        abbreviationStandard: '-04',
        id: 137,
        enabled: true
    },
    {
        name: 'America/St_Kitts',
        displayName: 'GMT-04:00 सेंट किट्स AST',
        nameLocalized: 'सेंट किट्स',
        abbreviationStandard: 'AST',
        id: 185
    },
    {
        name: 'America/St_Thomas',
        displayName: 'GMT-04:00 सेंट थॉमस AST',
        nameLocalized: 'सेंट थॉमस',
        abbreviationStandard: 'AST',
        id: 187
    },
    {
        name: 'America/St_Lucia',
        displayName: 'GMT-04:00 सेंट लूसिया AST',
        nameLocalized: 'सेंट लूसिया',
        abbreviationStandard: 'AST',
        id: 186
    },
    {
        name: 'America/St_Vincent',
        displayName: 'GMT-04:00 सेंट विंसेंट AST',
        nameLocalized: 'सेंट विंसेंट',
        abbreviationStandard: 'AST',
        id: 188
    },
    {
        name: 'America/Santo_Domingo',
        displayName: 'GMT-04:00 सेंटो डोमिंगो AST',
        nameLocalized: 'सेंटो डोमिंगो',
        abbreviationStandard: 'AST',
        id: 180
    },
    {
        name: 'America/Santiago',
        displayName: 'GMT-04:00 सैंटियागो -04/-03',
        nameLocalized: 'सैंटियागो',
        abbreviationStandard: '-04/-03',
        abbreviationDaylight: '-04/-03',
        id: 179,
        enabled: true
    },
    {
        name: 'America/Halifax',
        displayName: 'GMT-04:00 हेलिफ़ैक्स AST',
        nameLocalized: 'हेलिफ़ैक्स',
        abbreviationStandard: 'AST',
        abbreviationDaylight: 'ADT',
        id: 118
    },
    {
        name: 'Chile/Continental',
        displayName: 'GMT-04:00 Continental -04/-03',
        nameLocalized: 'Continental',
        abbreviationStandard: '-04/-03',
        abbreviationDaylight: '-04/-03',
        id: 346
    },
    {
        name: 'Etc/GMT-4',
        displayName: 'GMT-04:00 GMT-4 -04',
        nameLocalized: 'GMT-4',
        abbreviationStandard: '-04',
        id: 378
    },
    {
        name: 'Etc/GMT+4',
        displayName: 'GMT-04:00 GMT+4 -04',
        nameLocalized: 'GMT+4',
        abbreviationStandard: '-04',
        id: 363
    },
    {
        name: 'America/Virgin',
        displayName: 'GMT-04:00 Virgin AST',
        nameLocalized: 'Virgin',
        abbreviationStandard: 'AST',
        id: 197
    },
    {
        name: 'America/Coral_Harbour',
        displayName: 'GMT-05:00 अटिकोकान EST',
        nameLocalized: 'अटिकोकान',
        abbreviationStandard: 'EST',
        id: 92
    },
    {
        name: 'America/Indianapolis',
        displayName: 'GMT-05:00 इंडियानापोलिस EST',
        nameLocalized: 'इंडियानापोलिस',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 128
    },
    {
        name: 'America/Iqaluit',
        displayName: 'GMT-05:00 इकालुईट EST',
        nameLocalized: 'इकालुईट',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 130
    },
    {
        name: 'America/Eirunepe',
        displayName: 'GMT-05:00 ईरुनेपे -05',
        nameLocalized: 'ईरुनेपे',
        abbreviationStandard: '-05',
        id: 104
    },
    {
        name: 'America/Cancun',
        displayName: 'GMT-05:00 कैनकुन EST',
        nameLocalized: 'कैनकुन',
        abbreviationStandard: 'EST',
        id: 85
    },
    {
        name: 'America/Cayman',
        displayName: 'GMT-05:00 कैमेन EST',
        nameLocalized: 'कैमेन',
        abbreviationStandard: 'EST',
        id: 89
    },
    {
        name: 'America/Grand_Turk',
        displayName: 'GMT-05:00 ग्रांड टर्क EST',
        nameLocalized: 'ग्रांड टर्क',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 112
    },
    {
        name: 'America/Guayaquil',
        displayName: 'GMT-05:00 ग्वायाकील -05/-04',
        nameLocalized: 'ग्वायाकील',
        abbreviationStandard: '-05/-04',
        id: 116
    },
    {
        name: 'America/Jamaica',
        displayName: 'GMT-05:00 जमैका EST',
        nameLocalized: 'जमैका',
        abbreviationStandard: 'EST',
        id: 131
    },
    {
        name: 'America/Toronto',
        displayName: 'GMT-05:00 टोरंटो EST',
        nameLocalized: 'टोरंटो',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 194
    },
    {
        name: 'America/Detroit',
        displayName: 'GMT-05:00 डेट्रॉयट EST',
        nameLocalized: 'डेट्रॉयट',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 101
    },
    {
        name: 'America/Nassau',
        displayName: 'GMT-05:00 नासाउ EST',
        nameLocalized: 'नासाउ',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 156
    },
    {
        name: 'America/New_York',
        displayName: 'GMT-05:00 न्यूयॉर्क EST',
        nameLocalized: 'न्यूयॉर्क',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 157,
        enabled: true
    },
    {
        name: 'America/Panama',
        displayName: 'GMT-05:00 पनामा EST',
        nameLocalized: 'पनामा',
        abbreviationStandard: 'EST',
        id: 163
    },
    {
        name: 'America/Indiana/Petersburg',
        displayName: 'GMT-05:00 पीटर्सबर्ग, इंडियाना EST',
        nameLocalized: 'पीटर्सबर्ग, इंडियाना',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 124
    },
    {
        name: 'America/Port-au-Prince',
        displayName: 'GMT-05:00 पोर्ट-ऑ-प्रिंस EST',
        nameLocalized: 'पोर्ट-ऑ-प्रिंस',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 167
    },
    {
        name: 'America/Bogota',
        displayName: 'GMT-05:00 बोगोटा -05/-04',
        nameLocalized: 'बोगोटा',
        abbreviationStandard: '-05/-04',
        id: 80,
        enabled: true
    },
    {
        name: 'America/Indiana/Marengo',
        displayName: 'GMT-05:00 मारेंगो, इंडियाना EST',
        nameLocalized: 'मारेंगो, इंडियाना',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 123
    },
    {
        name: 'America/Kentucky/Monticello',
        displayName: 'GMT-05:00 मोंटीसेलो, केंटकी EST',
        nameLocalized: 'मोंटीसेलो, केंटकी',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 135
    },
    {
        name: 'America/Rio_Branco',
        displayName: 'GMT-05:00 रियो ब्रांको -05',
        nameLocalized: 'रियो ब्रांको',
        abbreviationStandard: '-05',
        id: 177
    },
    {
        name: 'America/Lima',
        displayName: 'GMT-05:00 लीमा -05/-04',
        nameLocalized: 'लीमा',
        abbreviationStandard: '-05/-04',
        id: 138
    },
    {
        name: 'America/Louisville',
        displayName: 'GMT-05:00 लुइसविले EST',
        nameLocalized: 'लुइसविले',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 140
    },
    {
        name: 'America/Indiana/Vincennes',
        displayName: 'GMT-05:00 विंसेनेस, इंडियाना EST',
        nameLocalized: 'विंसेनेस, इंडियाना',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 126
    },
    {
        name: 'America/Indiana/Winamac',
        displayName: 'GMT-05:00 विनामेक, इंडियाना EST',
        nameLocalized: 'विनामेक, इंडियाना',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 127
    },
    {
        name: 'America/Indiana/Vevay',
        displayName: 'GMT-05:00 वेवे, इंडियाना EST',
        nameLocalized: 'वेवे, इंडियाना',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 125
    },
    {
        name: 'America/Havana',
        displayName: 'GMT-05:00 हवाना CST',
        nameLocalized: 'हवाना',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 119
    },
    {
        name: 'Brazil/Acre',
        displayName: 'GMT-05:00 Acre -05',
        nameLocalized: 'Acre',
        abbreviationStandard: '-05',
        id: 332
    },
    {
        name: 'America/Atikokan',
        displayName: 'GMT-05:00 Atikokan EST',
        nameLocalized: 'Atikokan',
        abbreviationStandard: 'EST',
        id: 72
    },
    {
        name: 'US/East-Indiana',
        displayName: 'GMT-05:00 East-Indiana EST',
        nameLocalized: 'East-Indiana',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 539
    },
    {
        name: 'US/Eastern',
        displayName: 'GMT-05:00 Eastern EST',
        nameLocalized: 'Eastern',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 540
    },
    {
        name: 'EST',
        displayName: 'GMT-05:00 EST EST',
        nameLocalized: 'EST',
        abbreviationStandard: 'EST',
        id: 353
    },
    {
        name: 'EST5EDT',
        displayName: 'GMT-05:00 EST5EDT EST',
        nameLocalized: 'EST5EDT',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 354
    },
    {
        name: 'America/Fort_Wayne',
        displayName: 'GMT-05:00 Fort Wayne EST',
        nameLocalized: 'Fort Wayne',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 107
    },
    {
        name: 'Etc/GMT-5',
        displayName: 'GMT-05:00 GMT-5 -05',
        nameLocalized: 'GMT-5',
        abbreviationStandard: '-05',
        id: 379
    },
    {
        name: 'Etc/GMT+5',
        displayName: 'GMT-05:00 GMT+5 -05',
        nameLocalized: 'GMT+5',
        abbreviationStandard: '-05',
        id: 364
    },
    {
        name: 'America/Indiana/Indianapolis',
        displayName: 'GMT-05:00 Indianapolis EST',
        nameLocalized: 'Indianapolis',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 121
    },
    {
        name: 'America/Kentucky/Louisville',
        displayName: 'GMT-05:00 Louisville EST',
        nameLocalized: 'Louisville',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 134
    },
    {
        name: 'America/Montreal',
        displayName: 'GMT-05:00 Montreal EST',
        nameLocalized: 'Montreal',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 154
    },
    {
        name: 'America/Nipigon',
        displayName: 'GMT-05:00 Nipigon EST',
        nameLocalized: 'Nipigon',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 158
    },
    {
        name: 'America/Pangnirtung',
        displayName: 'GMT-05:00 Pangnirtung EST',
        nameLocalized: 'Pangnirtung',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 164
    },
    {
        name: 'America/Porto_Acre',
        displayName: 'GMT-05:00 Porto Acre -05',
        nameLocalized: 'Porto Acre',
        abbreviationStandard: '-05',
        id: 169
    },
    {
        name: 'America/Thunder_Bay',
        displayName: 'GMT-05:00 Thunder Bay EST',
        nameLocalized: 'Thunder Bay',
        abbreviationStandard: 'EST',
        abbreviationDaylight: 'EDT',
        id: 192
    },
    {
        name: 'America/El_Salvador',
        displayName: 'GMT-06:00 अल सल्वाडोर CST',
        nameLocalized: 'अल सल्वाडोर',
        abbreviationStandard: 'CST',
        id: 105
    },
    {
        name: 'Pacific/Easter',
        displayName: 'GMT-06:00 ईस्टर -06/-05',
        nameLocalized: 'ईस्टर',
        abbreviationStandard: '-06/-05',
        abbreviationDaylight: '-06/-05',
        id: 488
    },
    {
        name: 'America/Costa_Rica',
        displayName: 'GMT-06:00 कोस्टा रिका CST',
        nameLocalized: 'कोस्टा रिका',
        abbreviationStandard: 'CST',
        id: 94
    },
    {
        name: 'Pacific/Galapagos',
        displayName: 'GMT-06:00 गेलापागोस -06/-05',
        nameLocalized: 'गेलापागोस',
        abbreviationStandard: '-06/-05',
        id: 494
    },
    {
        name: 'America/Guatemala',
        displayName: 'GMT-06:00 ग्वाटेमाला CST',
        nameLocalized: 'ग्वाटेमाला',
        abbreviationStandard: 'CST',
        id: 115,
        enabled: true
    },
    {
        name: 'America/Chihuahua',
        displayName: 'GMT-06:00 चिहुआहुआ CST',
        nameLocalized: 'चिहुआहुआ',
        abbreviationStandard: 'CST',
        id: 91,
        enabled: true
    },
    {
        name: 'America/Tegucigalpa',
        displayName: 'GMT-06:00 टेगुसिगल्पा CST',
        nameLocalized: 'टेगुसिगल्पा',
        abbreviationStandard: 'CST',
        id: 190
    },
    {
        name: 'America/Indiana/Knox',
        displayName: 'GMT-06:00 नौक्स, इंडियाना CST',
        nameLocalized: 'नौक्स, इंडियाना',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 122
    },
    {
        name: 'America/North_Dakota/New_Salem',
        displayName: 'GMT-06:00 न्यू सालेम, उत्तरी डकोटा CST',
        nameLocalized: 'न्यू सालेम, उत्तरी डकोटा',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 162
    },
    {
        name: 'America/Belize',
        displayName: 'GMT-06:00 बेलीज़ CST',
        nameLocalized: 'बेलीज़',
        abbreviationStandard: 'CST',
        id: 77
    },
    {
        name: 'America/North_Dakota/Center',
        displayName: 'GMT-06:00 मध्य, उत्तरी दाकोता CST',
        nameLocalized: 'मध्य, उत्तरी दाकोता',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 161
    },
    {
        name: 'America/Managua',
        displayName: 'GMT-06:00 मानागुआ CST',
        nameLocalized: 'मानागुआ',
        abbreviationStandard: 'CST',
        id: 142
    },
    {
        name: 'America/Mexico_City',
        displayName: 'GMT-06:00 मेक्सिको सिटी CST',
        nameLocalized: 'मेक्सिको सिटी',
        abbreviationStandard: 'CST',
        id: 149,
        enabled: true
    },
    {
        name: 'America/Menominee',
        displayName: 'GMT-06:00 मेनोमिनी CST',
        nameLocalized: 'मेनोमिनी',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 147
    },
    {
        name: 'America/Merida',
        displayName: 'GMT-06:00 मेरिडा CST',
        nameLocalized: 'मेरिडा',
        abbreviationStandard: 'CST',
        id: 148
    },
    {
        name: 'America/Monterrey',
        displayName: 'GMT-06:00 मोंटेरेरी CST',
        nameLocalized: 'मोंटेरेरी',
        abbreviationStandard: 'CST',
        id: 152
    },
    {
        name: 'America/Resolute',
        displayName: 'GMT-06:00 रिसोल्यूट CST',
        nameLocalized: 'रिसोल्यूट',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 176
    },
    {
        name: 'America/Rankin_Inlet',
        displayName: 'GMT-06:00 रेंकिन इनलेट CST',
        nameLocalized: 'रेंकिन इनलेट',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 173
    },
    {
        name: 'America/Regina',
        displayName: 'GMT-06:00 रेजिना CST',
        nameLocalized: 'रेजिना',
        abbreviationStandard: 'CST',
        id: 175
    },
    {
        name: 'America/Winnipeg',
        displayName: 'GMT-06:00 विनीपेग CST',
        nameLocalized: 'विनीपेग',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 199
    },
    {
        name: 'America/Chicago',
        displayName: 'GMT-06:00 शिकागो CST',
        nameLocalized: 'शिकागो',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 90,
        enabled: true
    },
    {
        name: 'America/Swift_Current',
        displayName: 'GMT-06:00 स्विफ़्ट करंट CST',
        nameLocalized: 'स्विफ़्ट करंट',
        abbreviationStandard: 'CST',
        id: 189
    },
    {
        name: 'Canada/Central',
        displayName: 'GMT-06:00 Central CST',
        nameLocalized: 'Central',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 337
    },
    {
        name: 'CST6CDT',
        displayName: 'GMT-06:00 CST6CDT CST',
        nameLocalized: 'CST6CDT',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 348
    },
    {
        name: 'Mexico/General',
        displayName: 'GMT-06:00 General CST',
        nameLocalized: 'General',
        abbreviationStandard: 'CST',
        id: 479
    },
    {
        name: 'Etc/GMT-6',
        displayName: 'GMT-06:00 GMT-6 -06',
        nameLocalized: 'GMT-6',
        abbreviationStandard: '-06',
        id: 380
    },
    {
        name: 'Etc/GMT+6',
        displayName: 'GMT-06:00 GMT+6 -06',
        nameLocalized: 'GMT+6',
        abbreviationStandard: '-06',
        id: 365
    },
    {
        name: 'US/Indiana-Starke',
        displayName: 'GMT-06:00 Indiana-Starke CST',
        nameLocalized: 'Indiana-Starke',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 542
    },
    {
        name: 'America/Knox_IN',
        displayName: 'GMT-06:00 Knox IN CST',
        nameLocalized: 'Knox IN',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 136
    },
    {
        name: 'America/Rainy_River',
        displayName: 'GMT-06:00 Rainy River CST',
        nameLocalized: 'Rainy River',
        abbreviationStandard: 'CST',
        abbreviationDaylight: 'CDT',
        id: 172
    },
    {
        name: 'America/Inuvik',
        displayName: 'GMT-07:00 इनूविक MST',
        nameLocalized: 'इनूविक',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 129
    },
    {
        name: 'America/Edmonton',
        displayName: 'GMT-07:00 एडमंटन MST',
        nameLocalized: 'एडमंटन',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 103
    },
    {
        name: 'America/Cambridge_Bay',
        displayName: 'GMT-07:00 कैम्ब्रिज खाड़ी MST',
        nameLocalized: 'कैम्ब्रिज खाड़ी',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 83
    },
    {
        name: 'America/Denver',
        displayName: 'GMT-07:00 डेनवर MST',
        nameLocalized: 'डेनवर',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 100,
        enabled: true
    },
    {
        name: 'America/Dawson',
        displayName: 'GMT-07:00 डॉसन MST',
        nameLocalized: 'डॉसन',
        abbreviationStandard: 'MST',
        id: 98
    },
    {
        name: 'America/Dawson_Creek',
        displayName: 'GMT-07:00 डॉसन क्रीक MST',
        nameLocalized: 'डॉसन क्रीक',
        abbreviationStandard: 'MST',
        id: 99
    },
    {
        name: 'America/Phoenix',
        displayName: 'GMT-07:00 फ़ीनिक्स MST',
        nameLocalized: 'फ़ीनिक्स',
        abbreviationStandard: 'MST',
        id: 166,
        enabled: true
    },
    {
        name: 'America/Boise',
        displayName: 'GMT-07:00 बॉइसी MST',
        nameLocalized: 'बॉइसी',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 81
    },
    {
        name: 'America/Mazatlan',
        displayName: 'GMT-07:00 माज़ाटलान MST',
        nameLocalized: 'माज़ाटलान',
        abbreviationStandard: 'MST',
        id: 145
    },
    {
        name: 'America/Whitehorse',
        displayName: 'GMT-07:00 व्हाइटहोर्स MST',
        nameLocalized: 'व्हाइटहोर्स',
        abbreviationStandard: 'MST',
        id: 198
    },
    {
        name: 'America/Hermosillo',
        displayName: 'GMT-07:00 हर्मोसिल्लो MST',
        nameLocalized: 'हर्मोसिल्लो',
        abbreviationStandard: 'MST',
        id: 120
    },
    {
        name: 'Mexico/BajaSur',
        displayName: 'GMT-07:00 BajaSur MST',
        nameLocalized: 'BajaSur',
        abbreviationStandard: 'MST',
        id: 478
    },
    {
        name: 'Etc/GMT-7',
        displayName: 'GMT-07:00 GMT-7 -07',
        nameLocalized: 'GMT-7',
        abbreviationStandard: '-07',
        id: 381
    },
    {
        name: 'Etc/GMT+7',
        displayName: 'GMT-07:00 GMT+7 -07',
        nameLocalized: 'GMT+7',
        abbreviationStandard: '-07',
        id: 366
    },
    {
        name: 'Canada/Mountain',
        displayName: 'GMT-07:00 Mountain MST',
        nameLocalized: 'Mountain',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 340
    },
    {
        name: 'MST',
        displayName: 'GMT-07:00 MST MST',
        nameLocalized: 'MST',
        abbreviationStandard: 'MST',
        id: 480
    },
    {
        name: 'MST7MDT',
        displayName: 'GMT-07:00 MST7MDT MST',
        nameLocalized: 'MST7MDT',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 481
    },
    {
        name: 'America/Yellowknife',
        displayName: 'GMT-07:00 Yellowknife MST',
        nameLocalized: 'Yellowknife',
        abbreviationStandard: 'MST',
        abbreviationDaylight: 'MDT',
        id: 201
    },
    {
        name: 'Canada/Yukon',
        displayName: 'GMT-07:00 Yukon MST',
        nameLocalized: 'Yukon',
        abbreviationStandard: 'MST',
        id: 344
    },
    {
        name: 'America/Tijuana',
        displayName: 'GMT-08:00 तिजुआना PST',
        nameLocalized: 'तिजुआना',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 193,
        enabled: true
    },
    {
        name: 'Pacific/Pitcairn',
        displayName: 'GMT-08:00 पिटकैर्न -08',
        nameLocalized: 'पिटकैर्न',
        abbreviationStandard: '-08',
        id: 512
    },
    {
        name: 'America/Los_Angeles',
        displayName: 'GMT-08:00 लॉस एंजिल्स PST',
        nameLocalized: 'लॉस एंजिल्स',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 139,
        enabled: true
    },
    {
        name: 'America/Vancouver',
        displayName: 'GMT-08:00 वैंकूवर PST',
        nameLocalized: 'वैंकूवर',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 196
    },
    {
        name: 'America/Ensenada',
        displayName: 'GMT-08:00 Ensenada PST',
        nameLocalized: 'Ensenada',
        abbreviationStandard: 'PST',
        id: 106
    },
    {
        name: 'Etc/GMT-8',
        displayName: 'GMT-08:00 GMT-8 -08',
        nameLocalized: 'GMT-8',
        abbreviationStandard: '-08',
        id: 382
    },
    {
        name: 'Etc/GMT+8',
        displayName: 'GMT-08:00 GMT+8 -08',
        nameLocalized: 'GMT+8',
        abbreviationStandard: '-08',
        id: 367
    },
    {
        name: 'Canada/Pacific',
        displayName: 'GMT-08:00 Pacific PST',
        nameLocalized: 'Pacific',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 342
    },
    {
        name: 'US/Pacific',
        displayName: 'GMT-08:00 Pacific PST',
        nameLocalized: 'Pacific',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 545
    },
    {
        name: 'PST8PDT',
        displayName: 'GMT-08:00 PST8PDT PST',
        nameLocalized: 'PST8PDT',
        abbreviationStandard: 'PST',
        abbreviationDaylight: 'PDT',
        id: 528
    },
    {
        name: 'Pacific/Marquesas',
        displayName: 'GMT-09:30 मार्केसस -0930',
        nameLocalized: 'मार्केसस',
        abbreviationStandard: '-0930',
        id: 504
    },
    {
        name: 'America/Anchorage',
        displayName: 'GMT-09:00 एंकरेज AKST',
        nameLocalized: 'एंकरेज',
        abbreviationStandard: 'AKST',
        abbreviationDaylight: 'AKDT',
        id: 55
    },
    {
        name: 'Pacific/Gambier',
        displayName: 'GMT-09:00 गैंबियर -09',
        nameLocalized: 'गैंबियर',
        abbreviationStandard: '-09',
        id: 495
    },
    {
        name: 'America/Juneau',
        displayName: 'GMT-09:00 ज्यूनाउ AKST',
        nameLocalized: 'ज्यूनाउ',
        abbreviationStandard: 'AKST',
        abbreviationDaylight: 'AKDT',
        id: 133,
        enabled: true
    },
    {
        name: 'America/Nome',
        displayName: 'GMT-09:00 नोम AKST',
        nameLocalized: 'नोम',
        abbreviationStandard: 'AKST',
        abbreviationDaylight: 'AKDT',
        id: 159
    },
    {
        name: 'America/Yakutat',
        displayName: 'GMT-09:00 याकूटाट AKST',
        nameLocalized: 'याकूटाट',
        abbreviationStandard: 'AKST',
        abbreviationDaylight: 'AKDT',
        id: 200
    },
    {
        name: 'US/Alaska',
        displayName: 'GMT-09:00 Alaska AKST',
        nameLocalized: 'Alaska',
        abbreviationStandard: 'AKST',
        abbreviationDaylight: 'AKDT',
        id: 535
    },
    {
        name: 'Etc/GMT-9',
        displayName: 'GMT-09:00 GMT-9 -09',
        nameLocalized: 'GMT-9',
        abbreviationStandard: '-09',
        id: 383
    },
    {
        name: 'Etc/GMT+9',
        displayName: 'GMT-09:00 GMT+9 -09',
        nameLocalized: 'GMT+9',
        abbreviationStandard: '-09',
        id: 368
    },
    {
        name: 'America/Adak',
        displayName: 'GMT-10:00 अडक HST',
        nameLocalized: 'अडक',
        abbreviationStandard: 'HST',
        abbreviationDaylight: 'HDT',
        id: 54
    },
    {
        name: 'Pacific/Tahiti',
        displayName: 'GMT-10:00 ताहिती -10',
        nameLocalized: 'ताहिती',
        abbreviationStandard: '-10',
        id: 518
    },
    {
        name: 'Pacific/Rarotonga',
        displayName: 'GMT-10:00 रारोटोंगा -10/-0930',
        nameLocalized: 'रारोटोंगा',
        abbreviationStandard: '-10/-0930',
        id: 515
    },
    {
        name: 'Pacific/Honolulu',
        displayName: 'GMT-10:00 होनोलुलु HST',
        nameLocalized: 'होनोलुलु',
        abbreviationStandard: 'HST',
        id: 498,
        enabled: true
    },
    {
        name: 'Etc/GMT-10',
        displayName: 'GMT-10:00 GMT-10 -10',
        nameLocalized: 'GMT-10',
        abbreviationStandard: '-10',
        id: 371
    },
    {
        name: 'Etc/GMT+10',
        displayName: 'GMT-10:00 GMT+10 -10',
        nameLocalized: 'GMT+10',
        abbreviationStandard: '-10',
        id: 358
    },
    {
        name: 'US/Hawaii',
        displayName: 'GMT-10:00 Hawaii HST',
        nameLocalized: 'Hawaii',
        abbreviationStandard: 'HST',
        id: 541
    },
    {
        name: 'HST',
        displayName: 'GMT-10:00 HST HST',
        nameLocalized: 'HST',
        abbreviationStandard: 'HST',
        id: 457
    },
    {
        name: 'Pacific/Johnston',
        displayName: 'GMT-10:00 Johnston HST',
        nameLocalized: 'Johnston',
        abbreviationStandard: 'HST',
        id: 499
    },
    {
        name: 'Pacific/Niue',
        displayName: 'GMT-11:00 नीयू -11',
        nameLocalized: 'नीयू',
        abbreviationStandard: '-11',
        id: 507
    },
    {
        name: 'Pacific/Pago_Pago',
        displayName: 'GMT-11:00 पागो पागो SST',
        nameLocalized: 'पागो पागो',
        abbreviationStandard: 'SST',
        id: 510
    },
    {
        name: 'Pacific/Midway',
        displayName: 'GMT-11:00 मिडवे SST',
        nameLocalized: 'मिडवे',
        abbreviationStandard: 'SST',
        id: 505,
        enabled: true
    },
    {
        name: 'Etc/GMT-11',
        displayName: 'GMT-11:00 GMT-11 -11',
        nameLocalized: 'GMT-11',
        abbreviationStandard: '-11',
        id: 372
    },
    {
        name: 'Etc/GMT+11',
        displayName: 'GMT-11:00 GMT+11 -11',
        nameLocalized: 'GMT+11',
        abbreviationStandard: '-11',
        id: 359
    },
    {
        name: 'Pacific/Samoa',
        displayName: 'GMT-11:00 Samoa SST',
        nameLocalized: 'Samoa',
        abbreviationStandard: 'SST',
        id: 517
    },
    {
        name: 'US/Samoa',
        displayName: 'GMT-11:00 Samoa SST',
        nameLocalized: 'Samoa',
        abbreviationStandard: 'SST',
        id: 547
    },
    {
        name: 'Etc/GMT-12',
        displayName: 'GMT-12:00 GMT-12 -12',
        nameLocalized: 'GMT-12',
        abbreviationStandard: '-12',
        id: 373
    },
    {
        name: 'Etc/GMT+12',
        displayName: 'GMT-12:00 GMT+12 -12',
        nameLocalized: 'GMT+12',
        abbreviationStandard: '-12',
        id: 360
    },
];

const weekData: WeekData = {
    firstDay: 0,
    weekendStart: 0,
    weekendEnd: 0
};

const weekDayNames: WeekDayNameData = {
    days: {
        abbreviated: {
            sun: 'रवि',
            mon: 'सोम',
            tue: 'मंगल',
            wed: 'बुध',
            thu: 'गुरु',
            fri: 'शुक्र',
            sat: 'शनि',
        },
        narrow: {
            sun: 'र',
            mon: 'सो',
            tue: 'मं',
            wed: 'बु',
            thu: 'गु',
            fri: 'शु',
            sat: 'श',
        },
        short: {
            sun: 'र',
            mon: 'सो',
            tue: 'मं',
            wed: 'बु',
            thu: 'गु',
            fri: 'शु',
            sat: 'श',
        },
        wide: {
            sun: 'रविवार',
            mon: 'सोमवार',
            tue: 'मंगलवार',
            wed: 'बुधवार',
            thu: 'गुरुवार',
            fri: 'शुक्रवार',
            sat: 'शनिवार',
        },
    },
    standAlone: {
        abbreviated: {
            sun: 'रवि',
            mon: 'सोम',
            tue: 'मंगल',
            wed: 'बुध',
            thu: 'गुरु',
            fri: 'शुक्र',
            sat: 'शनि',
        },
        narrow: {
            sun: 'र',
            mon: 'सो',
            tue: 'मं',
            wed: 'बु',
            thu: 'गु',
            fri: 'शु',
            sat: 'श',
        },
        short: {
            sun: 'र',
            mon: 'सो',
            tue: 'मं',
            wed: 'बु',
            thu: 'गु',
            fri: 'शु',
            sat: 'श',
        },
        wide: {
            sun: 'रविवार',
            mon: 'सोमवार',
            tue: 'मंगलवार',
            wed: 'बुधवार',
            thu: 'गुरुवार',
            fri: 'शुक्रवार',
            sat: 'शनिवार',
        },
    },
};

const data: LocaleData = {
    languages,
    numbers,
    timezones,
    weekData,
    weekDayNames
};

export default data;
